import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from './shared-service/shared.service';
import { TimeoutComponent } from './timeout/timeout.component';
import { CepmService } from './services/cepm.service';
import { LoaderService } from './loader/loader.service';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { RouterConstants } from './constants/router-constants';
import { DashboardService } from './services/dashboard.service';
import { ToolsService } from './services/tools.service';
import { EncrDecrService } from './services/encrypt-decrypt.service';
import { MainMenuTab, SubMenuTabs, TabMenuGroup } from './constants/menu-panel-constants';
import { ContactManagementService } from './services/contact-management.service';
import { LookupService } from './services/lookup.service';
import { EditorConstants } from './constants/editor-constants';
import { RegionService } from './services/fetchRegion.service';
import { AgGridAngular } from 'ag-grid-angular';
import { DataRefreshRendererComponent } from './data-refresh-renderer/data-refresh-renderer.component';
import { SplunkLogsService } from './services/splunkLogs.service';
import { SupplierHomeService } from './services/supplier-home.service';
import { DateFilterService } from './services/date-filter.service';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { catchError, filter, interval, lastValueFrom, of, Subject, Subscription, switchMap, takeUntil, tap, timer } from 'rxjs';
import { SupplierWhitepaperService } from './services/supplier-whitepaper.service';
import { DataService } from './services/data.service';
import { NavigationService } from './services/navigation.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ChatbotDialogComponent } from './chatbot/chatbot/chatbot-dialog.component';
import { FormControl } from '@angular/forms';
import { NetworkService } from './services/network.service';
import { RasaWidgetService } from './services/rasa-widget.service';
import { FroalaEditorConstants } from './constants/froala-editor-constants';
import { Base64ToFileConverterService } from './services/base64-to-file-converter.service';
import { FeedbackNotificationService } from './services/feedback-notification.service';
import 'froala-editor/js/plugins.pkgd.min.js';
import { SwUpdate } from '@angular/service-worker';
declare let $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  isSocmRestricted: any = false;
  hideSectionsForSocm: any = true;
  isFilterOpened: any = false;
  loggedInUser: any = {};
  selectedSupplier: any = 'ALL';
  modalRefBox: any;
  isLoggedIn: any = false;
  browserScreenHeight: any = '';
  toolsList: any = [];
  showSubTabs = false;
  timeoutModalRefBox: any;
  searchedSupplier: any = '';
  supplierList: any = [];
  filteredSupplierList: any = [];
  searchedText = new FormControl();

  isAllCommoditiesSelected: any = false;
  selectedCommodity: any = [];
  commodityArr: any = [];
  commodityList: any = [];

  isAllSucmSelected: any = false;
  selectedSucm: any = [];
  sucmArr: any = [];
  sucmList: any = [];
  mainTabs: MainMenuTab[] = [];
  private shellReloadPromise: Promise<void> | null = null;
  selectedMainMenuIndex: any = 0;
  selectedTabMenuGrpIndex: any = 0;
  selectedSubMenuIndex: any = 0;
  openReportIssuesPopup: any = false;
  feedbackUnreadCount = 0;
  reportIssuesInitialTab: number = 1;
  disableToggleAnimation: any = true;
  infoPopup: any = false;
  tools = EditorConstants.modules;
  readMeInfo: any = '';
  isHelpPageOpened: any = false;
  isUserRestricted: any = false;
  isSupplierRestricted: any = false;
  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;
  sortSupplierType: any = '';
  isDataRefreshPopup: any = false;
  addSupplierNotes: any = false;
  viewSupplierNote: any = false;
  selectedSupplierNote: any = {};
  suppliers: any = [];
  mentionConfig: any = {};
  supplierNotes: any = '';
  enableSupplierNote: any = 'N';
  public frameworkComponents;
  public context;
  dynamicSupplierName = null;
  dynamicSurveyId = null;
  isHovering: boolean = false;
  isUserPersonaHovering: boolean = false;
  breadcrumbs: any[] = [];
  SCWTagLine: any = '';
  maxLinks = 5;
  visitedLinks: any[] = [];
  isWhitepaperAccess: any = false;
  hasFhrTrackerAccess: any = false;
  scrollMsg: any = '';
  favorites: Array<any> = [];
  enableDataRefresh: boolean = true;
  enableEditInfo: boolean = false;
  infoEditorOpen: boolean = false;
  dataRefreshInfoRes: any = '';
  dataRefreshInfoBody: any;
  faq = EditorConstants.modules;
  editorInstance: any;
  froalaOptions: any = JSON.parse(JSON.stringify(FroalaEditorConstants.froalaOptions));
  fadeOut = false;
  isRedirecting = false;
  lastVisibilityCheck = Date.now();
  visibilitySupplierList: any = [];
  openVotePopup: boolean = false;
  private dataRefreshPollSub?: Subscription;
  private newsInfoSub?: Subscription;
  private lastNewsInfoRequestKey = '';
  private visibilitySuppliersSub?: Subscription;
  private lastVisibilitySuppliersRequestKey = '';
  private favoritesLoadInProgress = false;
  private pollStop$ = new Subject<void>();
  private whitepaperAccessRequest: Promise<void> | null = null;
  private tagLineLookupRequested = false;
  @ViewChild("dataRefreshGrid") dataRefreshGrid: AgGridAngular;
  dataRefreshGridConfig: any = {
    rowData: [],
    columnDefs: [
      {
        headerName: "Action",
        field: "action",
        width: 60,
        cellRenderer: "dataRefreshRenderer",
        suppressMenu: true,
        filter: false,
        floatingFilter: false,
      },
      {
        headerName: "Metric",
        field: "metric",
        headerTooltip: "Metric",
        tooltipValueGetter: (params) => params.value,
      },
      {
        headerName: 'Last Refresh (PST Hrs)',
        field: 'lastRefresh',
        headerTooltip: 'Last Refresh (PST Hrs)',
        type: 'dateColumn',
        tooltipValueGetter: params => params.value
      },
      {
        headerName: 'Next Refresh (PST Hrs)',
        field: 'nextRefresh',
        headerTooltip: 'Next Refresh (PST Hrs)',
        type: 'dateColumn',
        tooltipValueGetter: params => params.value
      },
      {
        headerName: 'Last Successful Refresh (PST Hrs)',
        field: 'lastSuccessfulRefresh',
        headerTooltip: 'Last Successful Refresh (PST Hrs)',
        type: 'dateColumn',
        tooltipValueGetter: params => params.value
      },
      {
        headerName: 'Source',
        field: 'source',
        headerTooltip: 'Source',
        tooltipValueGetter: params => params.value,
        cellRenderer: 'dataRefreshRenderer'
      },
      {
        headerName: 'Frequency',
        field: 'frequency',
        headerTooltip: 'Frequency',
        tooltipValueGetter: params => params.value
      },
      {
        headerName: 'Job Status',
        field: 'jobStatus',
        headerTooltip: 'Job Status',
        tooltipValueGetter: params => params.value,
        cellRenderer: 'dataRefreshRenderer'
      }
    ]
  };

  dataRefreshGridDefaultColDef: any = {
    sortable: true,
    resizable: true,
    editable: false,
    enableRowGroup: false,
    floatingFilter: true,
    filter: 'agTextColumnFilter'
  }

  dataRefreshGridOptions: any = {
    tooltipShowDelay: 0
  };

  columnTypes: any = {
    dateColumn: {
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: (filterLocalDateAtMidnight, cellValue) => this.dateFilter.comparator(filterLocalDateAtMidnight, cellValue),
      },
      comparator: (date1: any, date2: any) => this.dateFilter.dateComparatorSort(date1, date2)
    }
  };

  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    public router: Router,
    private modalService: NgbModal,
    private sharedService: SharedService,
    private loaderService: LoaderService,
    private lookupService: LookupService,
    private supplierService: SupplierHomeService,
    private cepmService: CepmService,
    private dateFilter: DateFilterService,
    private dashboardService: DashboardService,
    public routerConstants: RouterConstants,
    private toolsService: ToolsService,
    private encDecSrvice: EncrDecrService,
    private contactsService: ContactManagementService,
    private cdRef: ChangeDetectorRef,
    private regionService: RegionService,
    private splunkLogsService: SplunkLogsService,
    private whitepaperService: SupplierWhitepaperService,
    private dataService: DataService,
    private navigationService: NavigationService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private networkService: NetworkService,
    public rasaWidgetService: RasaWidgetService,
    private readonly base64ToFileConverterService: Base64ToFileConverterService,
    private readonly swUpdate: SwUpdate,
    public feedbackNotificationService: FeedbackNotificationService
  ) {
    cdRef.detach();
    setInterval(() => {
      this.cdRef.detectChanges();
    }, 200);

    this.context = { componentParent: this };
    this.frameworkComponents = {
      dataRefreshRenderer: DataRefreshRendererComponent
    };

    this.browserScreenHeight = window.innerHeight;
    // Lazy route chunks load in the background; toggling the global loader here often
    // leaves the ref-count unbalanced after NavigationEnd has already cleared the spinner.
    // sets an idle timeout of 16 minutes (check if user is idle for 10mins)
    //idle.setIdle(1200);
    idle.setIdle(1800);


    // sets a timeout period of 1sec.
    // after 1sec of inactivity, the user will be considered timed out.
    idle.setTimeout(1);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onTimeout.subscribe(() => {
      const lastActiveTime = localStorage.getItem('lastActiveTime');
      if (!lastActiveTime || new Date(lastActiveTime) < new Date(Date.now() - idle.getIdle() * 1000)) {
        // No activity in any tabs, so proceed with the logout
        this.idleState = 'Timed out!';
        this.timedOut = true;
        this.modalService.dismissAll(ConfirmationComponent);
        $('.modal').hide();
        this.logout();
      } else {
        // There was activity in another tab, so reset the idle timer
        idle.watch();
      }
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = `You've gone idle!`;
      const lastActiveTime = localStorage.getItem('lastActiveTime');
      if (lastActiveTime && new Date(lastActiveTime) > new Date(Date.now() - idle.getIdle() * 1000)) {
        idle.watch();
      }
    });

    idle.onTimeoutWarning.subscribe((countdownInSecs) => {
      const minsLeft = (countdownInSecs - (countdownInSecs %= 60)) / 60 + (9 < countdownInSecs ? ':' : ':0') + countdownInSecs;
      this.idleState = `You will time out in ${minsLeft} minutes!`;
    });

    // sets the ping interval to 15 seconds
    keepalive.interval(15);

    keepalive.onPing.subscribe(() => this.lastPing = new Date());


    window.addEventListener('storage', (event) => {
      if (event.key === 'lastActiveTime') {
        this.idle.watch();
      }
    });


    // Lets check the path everytime the route changes, stop or start the idle check as appropriate.
    router.events.subscribe((event: any) => { (async () => {
      if (event instanceof NavigationEnd) {
        if (
          window.localStorage.getItem('cepmRespData') &&
          window.localStorage.getItem('type') !== 'login' &&
          (!this.isLoggedIn || !this.mainTabs?.length)
        ) {
          await this.bootstrapShellOnReload();
        }
        this.isHovering = false;
              if (!this.isRedirecting && this.isLoggedIn) {

        if (event.url.includes('general-user-home')) {
          this.onClickFilterPanel('open');
        }
        const selectedIndexOfMainMenu = Number(window.sessionStorage.getItem('selectedMainMenuIndex'));
        if ((event.url.includes('sucm-home/my-view') || event.url.includes('general-user-home') || event.url.includes('dashboard') || event.url.includes('sucm-home/overall-view') || event.url.includes('sucm-new-home')) && (this.selectedSupplier !== 'ALL') && (this.loggedInUser.role.value !== 'scw_supplier_user')) {
          const activeMainTab = this.mainTabs?.[selectedIndexOfMainMenu];
          if (activeMainTab?.labelName !== 'Admin'
            && selectedIndexOfMainMenu !== 20) {
            this.onSelectSupplier('ALL');
          }
        }

        const redirectedFromWP = this.encDecSrvice.get(window.localStorage.getItem('redirectedFromWP'));
        if ((redirectedFromWP == 'true') && (event.url.includes('fhr-detailed-view'))) {
          const selectSupp = this.encDecSrvice.get(window.localStorage.getItem('selectedSupplier'));
          window.localStorage.setItem('supplierName', this.encDecSrvice.set(selectSupp));
          window.localStorage.setItem('selectedSupplier', this.encDecSrvice.set(selectSupp));
          window.sessionStorage.setItem('selectedSupplier', this.encDecSrvice.set(selectSupp));
          window.localStorage.setItem('isFirstTimeNewsPopupVisited', 'true');
          window.localStorage.setItem('isFirstTimeNewsSectionVisited', 'true');
          window.localStorage.setItem('isSupplierRestricted', JSON.stringify(this.isSupplierRestricted));
          window.sessionStorage.setItem('selectedMainMenuIndex', "14");
          window.sessionStorage.setItem('selectedTabMenuGrpIndex', "0");
          window.sessionStorage.setItem('selectedSubMenuIndex', "3");
          this.initializeTabs();
          window.localStorage.setItem('redirectedFromWP', this.encDecSrvice.set('false'));
          await this.fetchDataBasedOnSearch('supplier', true);
        }
        if (event.url === '/logout') {
          this.modalService?.dismissAll();
          idle.stop();
        }
        else {
          idle.watch();
        }
        // const  redirectedFromWP = window.localStorage.getItem('redirectedFromWP');

        // Develop always cleared the global loader after route changes; restore that
        // safety net so ref-count drift during login bootstrap cannot leave a stuck spinner.
        this.loaderService.forceCloseLoader();
        this.scrollMessage();
        this.getNewsInfo();
      }
    }
    })(); });
    this.reset();
    const visitedLinksString = sessionStorage.getItem('visitedLinks');
    if (visitedLinksString) {
      this.visitedLinks = JSON.parse(visitedLinksString);
    }
  }

  openChatbot() {
    this.dialog.open(ChatbotDialogComponent, {
      width: '800px',
      height: '600px',
      position: {
        bottom: '0px',
        right: '0px'
      },
    });
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }


  ngOnInit(): void {
    (async () => {
    this.feedbackNotificationService.unreadCount$.subscribe((count) => {
      this.feedbackUnreadCount = count;
    });
    //this.checkForApplicationUpdates();
    this.setupActivityListener();

    // check event if user has clicked on loggedIn back
    this.sharedService.getClickEvent().subscribe((data: any) => {
      if (data) {
        //window.localStorage.clear();
        //this.initializeLoggedInVariables();
        window.location.href = '/';
        const userID = this.loggedInUser?.userId;
        const customData = {
          language: 'en',
          role: 'scw_internal',
          user_id: userID,
          source: 'InApp_Chatbot',
          environment: this.loggedInUser?.environment,
          app_name: "Supplier Connection Workbench"
        };
        if (this.loggedInUser?.scChatIconEnabled === "Y" && this.isLoggedIn) {
          this.rasaWidgetService.loadRasaWidget(customData);
        }
      }
      else {
        this.logout();
      }
    });

    this.sharedService.getTabClickEvent().subscribe((data: any) => {
      if (data) {
        this.breadcrumbs = this.generateBreadcrumbs(this.mainTabs, data);
      }
    })

    this.sharedService.getNonBaaoSupp().subscribe((data: any) => {
      if (data) {
        this.initializeFilterList();
      }
    });

    this.sharedService.getDataRefreshInfoPopupRequest().subscribe((open: boolean) => {
      if (open) {
        this.openDataRefreshInfoPopup();
      }
    });

    this.sharedService.getLogOut().subscribe((data: any) => {
      if (data) {
        this.feedbackNotificationService.stop();
        this.onClickLogout();
      }
    });

    this.routerConstants.getIsPageReloaded().subscribe((data: any) => { (async () => {
      if (data) {
        await this.bootstrapShellOnReload();
        const userID = this.loggedInUser?.userId;
        const customData = {
          language: 'en',
          role: 'scw_internal',
          user_id: userID,
          source: 'InApp_Chatbot',
          environment: this.loggedInUser?.environment,
          app_name: "Supplier Connection Workbench"
        };
        if (this.loggedInUser?.scChatIconEnabled === "Y" && this.isLoggedIn) {
          this.rasaWidgetService.loadRasaWidget(customData);
        } else {
        }
        this.getTagLineLookupValues();
        this.scrollMessage();
        this.getNewsInfo();

      }
    })(); });

    this.sharedService.getSupplierNote().subscribe((data: any) => {
      this.onSelectSupplier({ supplierName: data });
    });

    this.sharedService.getRedirectionUrl().subscribe((url: any) => { (async () => {
      const redirectedFromTo = window.localStorage.getItem('redirectedFrom-To');
      const redirectedToMainTab = redirectedFromTo.split('-')[1].toLowerCase().trim();
      const redirectedFrom = redirectedFromTo.split('-')[0].toLowerCase().trim();
      window.localStorage.removeItem('redirectedFrom-To');
      if ((redirectedFrom === 'contacts' && this.displaySelectedSuplier() === 'ALL') || redirectedFrom === 'sucm home') {
        await this.onSelectSupplier({ supplierName: this.encDecSrvice.get(window.localStorage.getItem('selectedSupplier')) }, true);
      }

      let visibleTabs = this.mainTabs.filter(
        (mainTab) => mainTab.isMainTabVisible && mainTab.mainTabName.toLowerCase() === redirectedToMainTab,
      );
      if (visibleTabs.length > 1) {
        const adminTabs = visibleTabs.filter((mainTab) => mainTab.labelName === 'Admin');
        visibleTabs = adminTabs.length > 0 ? adminTabs : visibleTabs;
      }
      window.localStorage.setItem('previousUrl', this.router.url);
      const targetUrl = `/${url}`;
      for (const mainTab of visibleTabs) {
        if (mainTab.tabGroups.length === 0) {
          if (mainTab.mainTabUrl === targetUrl) {
            this.onClickMainMenuTab(mainTab);
            break;
          }
        }
        else {
          for (const tabGrp of mainTab.tabGroups) {
            const matchedSubTab = this.findSubTabForRedirection(tabGrp.subTabs, targetUrl);
            if (matchedSubTab) {
              this.onClickSubMenuTab(mainTab, tabGrp, { ...matchedSubTab, subTabUrl: targetUrl });
              break;
            }
          }
        }
      }
    })(); });

    this.sharedService.getQuickTour().subscribe((data: any) => {
      if (data === 'open' || data === 'close') {
        this.onClickQuickTour(data);
      }
    });

    this.sharedService.getFilterPanelValue().subscribe((data: any) => {
      this.onClickFilterPanel(data);
    });

    const currentUrl: any = window.location.href;

    if (currentUrl && (!currentUrl.split('/')[3] || currentUrl.split('/')[3] === 'callback')) {

      //window.localStorage.clear();
      const respData = JSON.parse(window.localStorage.getItem('cepmRespData'));
      if (respData?.roles?.length > 0) {
        const userObj = this.cepmService.setUserObject(respData);
        this.routerConstants.setLoggedInUser(userObj);
        this.routerConstants.setUserType(userObj.role.value);
        this.isLoggedIn = true;
        this.loggedInUser = this.routerConstants.getLoggedInUser();
        this.feedbackNotificationService.start();
        await this.checkIfUserIsWhitepaperAdmin();
        await this.checkIfUserHasFhrTrackerAccess();
        await this.initializeTabs();
        this.redirectBasedOnRole();
      } else {
        // Preserve the deep link captured during the OAuth callback; clearing storage here
        // would otherwise drop it before redirectBasedOnRole() can consume it.
        const pendingPath = window.localStorage.getItem('path');
        window.localStorage.clear();
        if (pendingPath) {
          window.localStorage.setItem('path', pendingPath);
        }
        await this.getCepmRoles('login');
      }

      const userID = this.loggedInUser?.userId;
      const customData = {
        language: 'en',
        role: 'scw_internal',
        user_id: userID,
        source: 'InApp_Chatbot',
        environment: this.loggedInUser?.environment,
        app_name: "Supplier Connection Workbench"
      };
      if (this.loggedInUser?.scChatIconEnabled === "Y" && this.isLoggedIn) {
        this.rasaWidgetService.loadRasaWidget(customData);
      } else {
      }

      this.getTagLineLookupValues();
      this.scrollMessage();
      //this.getNewsInfo();

    }
    else if (window.localStorage.length > 0) {
      await this.bootstrapShellOnReload();
    }
    else {
      // without log in user tries to open url in different tab
      //this.logout();
    }
    //this.getTagLineLookupValues();
    //this.scrollMessage(); 


    if (this.mainTabs?.length) {
      this.breadcrumbs = this.generateBreadcrumbs(this.mainTabs);
    }
    this.configureFroalaEditor();
    })();
  }

  // Helper method to validate and remove oversized images
  private validateAndRemoveOversizedImages(): void {
    const images = this.editorInstance._editor.$el.find('img');
    images.each((_: number, img: any) => {
      const imageElement = $(img);
      const fileSize = this.base64ToFileConverterService.calculateBase64ImageSize(imageElement?.attr('src'));
      if (fileSize > 512) {
        alert('The uploaded image size exceeds the 512 KB limit.');
        const tempImage = new Image();
        tempImage.src = imageElement?.attr('src');
        tempImage.onload = () => {
          imageElement?.remove();
        };
      }
    });
  }

  // Helper method to handle image paste DOM manipulation
  private handleImagePasteDomManipulation(): void {
    const editor = this.editorInstance._editor;
    const $images = editor.$el.find('img');
    
    if ($images.length > 0) {
      const $img = $images.last();
      const $parent = $img.parent();
      
      if (($parent.is('p') || $parent.is('div')) && $parent.contents().length === 1) {
        $img.insertAfter($parent);
        $parent.remove();
      }
      
      if ($img.next().is('br')) {
        $img.next().remove();
      }
      
      editor.selection.setAfter($img[0]);
      editor.selection.restore();
    }
    
    const html = editor.html.get();
    if (this.dataRefreshInfoBody) {
      this.dataRefreshInfoBody = html;
    }
  }

  // Configure Froala editor options and event handlers
  private configureFroalaEditor(): void {
    this.froalaOptions.imageDefaultWidth = 300;
    this.froalaOptions.imageInsertButtons = ['imageUpload'];
    this.froalaOptions.imageEditButtons = ['imageDisplay', 'imageAlign', 'imageInfo', 'imageRemove'];
    this.froalaOptions.toolbarButtons.moreRich.buttons.push('insertTable');
    this.froalaOptions.toolbarButtons.moreRich.buttons.push('insertImage');

    this.froalaOptions.events = {
      initialized: (editor: any) => {
        this.editorInstance = editor;
        const content = FroalaEditorConstants.normalizeContentForFroala(editor._editor.html.get());
        editor._editor.html.set(content);
      },
      'paste.afterCleanup': (clipboardHtml: string) => {
        return FroalaEditorConstants.normalizeContentForFroala(clipboardHtml);
      },
      'image.beforeUpload': (files: FileList) => {
        if (files.length) {
          if (this.isInvalidFileSize(files[0]) || this.isInvalidFileExtension(files[0])) {
            return false;
          }
          const reader = new FileReader();
          reader.onload = (e: any) => {
            const base64String = e.target.result;
            this.editorInstance._editor.image.insert(base64String, null, null, this.editorInstance._editor.image.get());
          };
          reader.readAsDataURL(files[0]);
          return false;
        }
        return true;
      },
      'image.beforePasteUpload': () => {
        this.validateAndRemoveOversizedImages();
        return false;
      },
      'paste.after': () => {
        setTimeout(() => this.handleImagePasteDomManipulation(), 0);
      }
    };
  }

  initializeLoggedInVariables() {
    this.isFilterOpened = false;
    this.selectedMainMenuIndex = 0;
    this.selectedTabMenuGrpIndex = 0;
    this.selectedSubMenuIndex = 0;
    this.selectedSupplier = 'ALL';
    this.isLoggedIn = false;
    this.addSupplierNotes = false;
    this.viewSupplierNote = false;
    this.selectedSupplierNote = {};
    this.suppliers = [];
    this.mentionConfig = {};
    this.supplierNotes = '';
    this.enableSupplierNote = 'N';

    this.searchedSupplier = '';
    this.supplierList = [];
    this.filteredSupplierList = [];

    this.isAllCommoditiesSelected = false;
    this.selectedCommodity = [];
    this.commodityArr = [];
    this.commodityList = [];

    this.isAllSucmSelected = false;
    this.selectedSucm = [];
    this.sucmArr = [];
    this.sucmList = [];

    this.mainTabs = [];
    this.openReportIssuesPopup = false;
    this.disableToggleAnimation = true;
  }

  async getCepmRoles(type: any) {
    // fetch Ip Address and Region
    this.regionService.getIpAddr();
    if (type === 'login') {
      this.loggedInUser = {};
      this.initializeFilterVariables();
      window.localStorage.setItem('type', 'login');
      await this.cepmService.getCepmRole(false);
      this.loggedInUser = this.routerConstants.getLoggedInUser();
      if (this.loggedInUser && Object.keys(this.loggedInUser).length > 0 && this.loggedInUser.role.value) {
        if (this.loggedInUser.supplierScope === 'Y') {
          this.loaderService.openLoader();
          let respData: any;
          try {
            respData = await lastValueFrom(this.contactsService.checkInternalContact())
              .catch((err: any) => {
                this.openConfirmationPopup('Error', err.error.errorMsg, false);
                return null;
              });
          } finally {
            this.loaderService.closeLoader();
          }
          if (respData && Object.keys(respData).length > 0 && respData.status === 'S') {
            this.isLoggedIn = (this.loggedInUser && Object.keys(this.loggedInUser).length > 0) ? true : false;
            this.feedbackNotificationService.start();
            // if (this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' || this.loggedInUser.role.value === 'sourcing_commodity_manager_socm' || this.loggedInUser.role.value === 'commodity_directors' || this.loggedInUser.role.value === 'supply_chain_view_access') {
            //   await this.checkIfUserAccessIsRestricted();
            // }

            if ((this.loggedInUser.role.value === 'scw_supplier_user' && this.loggedInUser.nonRFQScope === 'Y')
              || this.loggedInUser.role.value !== 'scw_supplier_user') {
              if (this.loggedInUser.role.value !== 'scw_supplier_user') {
                await this.checkIfUserIsWhitepaperAdmin();
                await this.checkIfUserHasFhrTrackerAccess();
              }
              await this.initializeTabs();
              this.redirectBasedOnRole();
            }
          }
          else {
            //this.logout();
          }
        }
        else if (this.loggedInUser.supplierScope === 'N') {
          this.isLoggedIn = false;
          window.localStorage.clear();
          this.router.navigate(['/supplier-out-of-scope']);
        }
      }
      else {
        this.redirectBasedOnRole();
      }
    }
    else {
      this.loggedInUser = this.routerConstants.getLoggedInUser();
      if (!this.loggedInUser?.role?.value) {
        return;
      }
      this.selectedSupplier = this.encDecSrvice.get(window.localStorage.getItem('selectedSupplier')) || 'ALL';
      this.isSupplierRestricted = JSON.parse(window.localStorage.getItem('isSupplierRestricted') || 'false');
      this.isLoggedIn = true;
      this.feedbackNotificationService.start();
      if (this.loggedInUser.role.value !== 'scw_supplier_user') {
        await this.checkIfUserIsWhitepaperAdmin();
        await this.checkIfUserHasFhrTrackerAccess();
        try {
          this.getFilterList();
        } catch (error) {
          console.error('getFilterList failed during reload bootstrap', error);
        }
        await this.initializeTabs();
      }
      else {
        this.selectedSupplier = this.encDecSrvice.get(window.localStorage.getItem('selectedSupplier'));
        this.initializeTabs();
      }
    }
  }

  /** Idempotent F5/deep-link shell restore: login state, main menu, breadcrumbs. */
  private bootstrapShellOnReload(): Promise<void> {
    if (this.shellReloadPromise !== null) {
      return this.shellReloadPromise;
    }
    this.shellReloadPromise = this.runShellReloadBootstrap().finally(() => {
      this.shellReloadPromise = null;
    });
    return this.shellReloadPromise;
  }

  private async runShellReloadBootstrap(): Promise<void> {
    const cepmRespRaw = window.localStorage.getItem('cepmRespData');
    if (!cepmRespRaw) {
      return;
    }

    try {
      const respData = JSON.parse(cepmRespRaw);
      if (respData?.roles?.length > 0) {
        this.isLoggedIn = true;
      }
    } catch {
      return;
    }

    window.localStorage.setItem('type', 'reload');
    this.selectedMainMenuIndex = Number(window.sessionStorage.getItem('selectedMainMenuIndex')) || 0;
    this.selectedTabMenuGrpIndex = Number(window.sessionStorage.getItem('selectedTabMenuGrpIndex')) || 0;
    this.selectedSubMenuIndex = Number(window.sessionStorage.getItem('selectedSubMenuIndex')) || 0;

    await this.cepmService.getCepmRole(true);
    await this.getCepmRoles('reload');
    this.syncMenuSelectionFromCurrentUrl();
    if (this.mainTabs?.length) {
      this.breadcrumbs = this.generateBreadcrumbs(this.mainTabs);
    }
    this.isLoggedIn = !!(this.loggedInUser?.role?.value && this.mainTabs?.length);
    window.localStorage.removeItem('type');
    this.cdRef.detectChanges();
  }

  async checkIfUserIsWhitepaperAdmin() {
    if (this.whitepaperAccessRequest !== null) {
      return this.whitepaperAccessRequest;
    }

    this.whitepaperAccessRequest = this.loadWhitepaperAccess();
    try {
      await this.whitepaperAccessRequest;
    } finally {
      this.whitepaperAccessRequest = null;
    }
  }

  private async loadWhitepaperAccess(): Promise<void> {
    let isGsmEmployee: any = false;
    this.isWhitepaperAccess = false;
    let loggedInUser = this.routerConstants.getLoggedInUser();
    this.isWhitepaperAccess = this.loggedInUser.isWhitepaperAdmin === 'Y' ? true : false;
    if (!this.isWhitepaperAccess) {
      try {
        const response = await lastValueFrom(
          this.whitepaperService.getAllGSMUsers().pipe(
            tap((response: any) => {
              // Check if the user has whitepaper access
              if (response && response.length > 0) {
                this.isWhitepaperAccess = response.filter((r: any) => r.cec_id === this.loggedInUser.userId).length > 0 ? true : false;
                isGsmEmployee = response.filter((r: any) => r.cec_id === this.loggedInUser.userId).length > 0;
              }
            }),
            catchError((err: any) => {
              console.error('Error fetching GSM users:', err);
              return of(null); // Return a fallback value
            })
          )
        );
      } catch (error) {
        console.error('Error in service call:', error);
      }
    }

    loggedInUser.hasWhitepaperAccess = this.isWhitepaperAccess ? 'Y' : 'N';
    loggedInUser.isGsmEmployee = isGsmEmployee ? 'Y' : 'N';
    this.routerConstants.setLoggedInUser(loggedInUser);
  }

  async checkIfUserHasFhrTrackerAccess() {
    let loggedInUser = this.routerConstants.getLoggedInUser();
    if (loggedInUser?.role?.value === 'supply_chain_view_access') {
      this.hasFhrTrackerAccess = false;
      try {
        const response = await lastValueFrom(
          this.lookupService.getDropdownLookup('SCW_FHR_TRACKER_ACCESS').pipe(
            tap((response: any) => {
              // Check if the user has whitepaper access
              if (response?.lookupArray?.length > 0) {
                this.hasFhrTrackerAccess = response.lookupArray.filter((r: any) => r.description?.toUpperCase() === this.loggedInUser?.userId?.toUpperCase()).length > 0;
              }
            }),
            catchError((err: any) => {
              console.error('Error fetching GSM users:', err);
              return of(null); // Return a fallback value
            })
          )
        );
      } catch (error) {
        console.error('Error in service call:', error);
      }
    }
    else {
      this.hasFhrTrackerAccess = true;
    }
  }

  private static readonly WHITEPAPER_ROOT = '/supplier-whitepaper/';
  private static readonly WHITEPAPER_SUB_ROUTES = [
    'active-whitepapers',
    'published-whitepapers',
    'archived-whitepapers',
    'deleted-whitepapers',
    'published-executive-briefing-whitepapers'
  ];

  /** Keeps a requested whitepaper sub-route (e.g. a deep link from email) instead of always
   *  falling back to the role's default whitepaper landing tab. */
  private resolveWhitepaperRedirectionUrl(url: string, defaultUrl: string): string {
    const [root, subRoute] = url.split('?')[0].replace(/^\//, '').split('/');
    return root === 'supplier-whitepaper' && AppComponent.WHITEPAPER_SUB_ROUTES.includes(subRoute)
      ? `supplier-whitepaper/${subRoute}`
      : defaultUrl;
  }

  /** Whitepaper sub-routes other than the menu entry have no dedicated sub-tab, so fall back to
   *  the Supplier Whitepaper tab that shares the same route root. */
  private findSubTabForRedirection(subTabs: SubMenuTabs[], targetUrl: string): SubMenuTabs | undefined {
    const exactMatch = subTabs.find((subTab) => subTab.subTabUrl === targetUrl);
    if (exactMatch || !targetUrl.startsWith(AppComponent.WHITEPAPER_ROOT)) {
      return exactMatch;
    }
    return subTabs.find((subTab) => subTab.subTabUrl?.startsWith(AppComponent.WHITEPAPER_ROOT));
  }

  private async applyIncidentDeepLinkContext(parts: string[]): Promise<void> {
    const supplierName = parts[2] ? decodeURIComponent(parts[2]) || '' : '';
    const surveyId = parts[3] || '';
    if (!supplierName || !surveyId) {
      return;
    }

    window.localStorage.setItem('selectedSurveyIdUrl', this.encDecSrvice.set(surveyId));
    if (this.loggedInUser.role.value === 'scw_supplier_user') {
      window.localStorage.setItem('fromexternalUrlSupplierLogin', 'true');
      return;
    }

    const encryptedSupplierName = this.encDecSrvice.set(supplierName);
    this.selectedSupplier = supplierName;
    this.isSupplierRestricted = false;
    window.localStorage.setItem('selectedSupplierUrl', encryptedSupplierName);
    window.localStorage.setItem('supplierName', encryptedSupplierName);
    window.localStorage.setItem('selectedSupplier', encryptedSupplierName);
    window.sessionStorage.setItem('selectedSupplier', encryptedSupplierName);
    window.localStorage.setItem('isSupplierRestricted', JSON.stringify(this.isSupplierRestricted));
    window.localStorage.setItem('fromexternalUrl', 'true');
    await this.initializeTabs();
  }

  async redirectBasedOnRole() {
    if (this.loggedInUser && Object.keys(this.loggedInUser).length > 0 && this.loggedInUser.role.value) {
      this.selectedSupplier = this.loggedInUser.role.value === 'scw_supplier_user' ?
        this.loggedInUser.mcoCompany : this.selectedSupplier;
      window.localStorage.setItem('supplierName', this.encDecSrvice.set(this.selectedSupplier));
      window.localStorage.setItem('selectedSupplier', this.encDecSrvice.set(this.selectedSupplier));
      window.sessionStorage.setItem('selectedSupplier', this.encDecSrvice.set(this.selectedSupplier));
      window.localStorage.setItem('showNavigationHelpPopup', 'true');

      const validRoles = [
        'scw_admin',
        'supplier_commodity_manager_sucm',
        'sourcing_commodity_manager_socm',
        'commodity_directors',
        'gsm_general_user_okta',
        'supply_chain_view_access',
        'scw_supplier_user'
      ];

      if (!validRoles.includes(this.loggedInUser.role.value)) {
        this.isLoggedIn = false;
        // Don't clear all localStorage to prevent losing important session data
        // Only clear user-specific data
        window.localStorage.removeItem('loggedInUser');
        window.localStorage.removeItem('userToken');
        window.localStorage.removeItem('supplierName');
        window.localStorage.removeItem('selectedSupplier');
        window.sessionStorage.removeItem('selectedSupplier');
        window.localStorage.setItem('isInternal', 'true');
        this.router.navigate(['/no-cepm-role']);
        return; // Exit early to prevent further processing
      }


      let url = this.router.url;
      if (url === '/' || url.startsWith('/callback') || window.localStorage.getItem('path')) {
        const defaultPath = this.loggedInUser.role.value === 'scw_supplier_user' ? 'supplier-new-home' : 'sucm-home/overall-view';
        const storedPath = window.localStorage.getItem('path');
        const browserPath = window.location.pathname;
        if (storedPath) {
          url = storedPath;
        }
        else if (browserPath && browserPath !== '/' && !browserPath.startsWith('/callback')) {
          // Already-authenticated deep links (e.g. opening an email link in a new tab)
          // reach this point before the router finishes its initial navigation, so
          // this.router.url is still '/'. Recover the intended destination from the
          // browser URL instead of falling back to the role's default home page.
          url = browserPath;
        }
        else {
          url = defaultPath;
        }
        window.localStorage.removeItem('path');
      }
      let parts = url.split('/');

      let redirectedFromTo = '';
      let redirectionUrl = '';
      if (this.loggedInUser.role.value === 'scw_admin' || this.loggedInUser.role.value === 'scw_supplier_user') {
        if (this.loggedInUser.role.value === 'scw_admin') {
          await this.initializeFilterList();
        }
        let redirection = url.substring(1);
        const mainTabName = this.getMainTabNameByUrl(url);
        if (url === '/fhr-tracker') {
          redirectionUrl = 'fhr-tracker/current-mapping';
          redirectedFromTo = 'Login-Admin';
        }
        else if (url.includes('/documents')) {
          if (url.includes('/documents/training-documents')) {
            // Suppliers have a dedicated "Training" main tab, but for internal roles the
            // training docs live in the admin/collaboration tab (mainTabName 'Collaboration'),
            // which renders with the "Admin" label for scw_admin (e.g. Admin/Trainings).
            redirectedFromTo = this.loggedInUser.role.value === 'scw_supplier_user' ? 'Login-Training' : 'Login-Collaboration';
            redirectionUrl = 'documents/training-documents';
          }
          else {
            redirectedFromTo = 'Login-Collaboration';
            redirectionUrl = url.includes('/documents/') ? url.substring(1) : 'documents/cisco-documents';
          }
        }
        else if (url.includes('/supplier-whitepaper')) {
          redirectedFromTo = 'Login-Collaboration';
          redirectionUrl = this.resolveWhitepaperRedirectionUrl(url, this.loggedInUser?.userId === 'mdemarti' ? 'supplier-whitepaper/published-whitepapers' : 'supplier-whitepaper/active-whitepapers');
        }
        else if (url.includes('download') && parts[2] && parts[3] && parts[4]) {
          window.localStorage.setItem('externalDownloadFlag', 'true');
          window.localStorage.setItem('downloadSection', parts[2]);
          window.localStorage.setItem('downloadFlag', parts[3]);
          window.localStorage.setItem('downloadId', parts[4]);

          redirectedFromTo = this.loggedInUser.role.value === 'scw_supplier_user' ? 'Login-SCW Home' : 'Login-Admin';
          redirectionUrl = 'download';
        }
        else if (url.includes('incident-management') && parts[2] && parts[3]) {
          await this.applyIncidentDeepLinkContext(parts);
          redirectedFromTo = 'Login-Collaboration';
          redirectionUrl = 'incident-management';
        }
        else if (url === '/' || url.startsWith('/callback')) {
          if (this.loggedInUser.role.value === 'scw_supplier_user') {
            window.localStorage.setItem('isFirstTimeNewsPopupVisited', 'true');
            window.localStorage.setItem('isFirstTimeNewsSectionVisited', 'true');
            redirectedFromTo = 'Login-Home';
            redirectionUrl = 'supplier-new-home';
          }
          else if (this.loggedInUser.role.value === 'scw_admin') {
            redirectedFromTo = 'Login-AdminUser';
            redirectionUrl = 'sucm-home/overall-view';
          }
        }
        else if (this.loggedInUser.role.value === 'scw_supplier_user' && window.location.href.includes('supplier-new-home')) {
          window.localStorage.setItem('isFirstTimeNewsPopupVisited', 'true');
          window.localStorage.setItem('isFirstTimeNewsSectionVisited', 'true');
          redirectedFromTo = 'Login-Home';
          redirectionUrl = 'supplier-new-home';
        }
        else if (mainTabName) {
          redirectedFromTo = 'Login-' + mainTabName;
          redirectionUrl = redirection;
        }
        else {
          if (this.loggedInUser.role.value === 'scw_supplier_user') {
            window.localStorage.setItem('isFirstTimeNewsPopupVisited', 'true');
            window.localStorage.setItem('isFirstTimeNewsSectionVisited', 'true');
            redirectedFromTo = 'Login-Home';
            redirectionUrl = 'supplier-new-home';
          }
          else if (this.loggedInUser.role.value === 'scw_admin') {
            redirectedFromTo = 'Login-AdminUser';
            redirectionUrl = 'sucm-home/overall-view';
          }
        }
      }
      else if (this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' || this.loggedInUser.role.value === 'sourcing_commodity_manager_socm'
        || this.loggedInUser.role.value === 'commodity_directors'
      ) {
        await this.initializeFilterList();
        let redirection = url.substring(1);
        const mainTabName = this.getMainTabNameByUrl(url);
        if (url === '/fhr-tracker') {
          redirectionUrl = 'fhr-tracker/supplier-view';
          redirectedFromTo = 'Login-Collaboration';
        }
        else if (url.includes('incident-management') && parts[2] && parts[3]) {
          await this.applyIncidentDeepLinkContext(parts);
          redirectedFromTo = 'Login-Collaboration';
          redirectionUrl = 'incident-management';
        }
        else if (url.includes('/supplier-whitepaper')) {
          redirectedFromTo = 'Login-Collaboration';
          redirectionUrl = this.resolveWhitepaperRedirectionUrl(url, this.loggedInUser?.userId === 'mdemarti' || (this.loggedInUser?.role.value === 'commodity_directors' && this.loggedInUser?.isGsmEmployee === 'Y') ? 'supplier-whitepaper/published-whitepapers' : 'supplier-whitepaper/active-whitepapers');
        }
        else if (url.includes('/documents')) {
          if (url.includes('/documents/training-documents')) {
            redirectedFromTo = 'Login-Collaboration';
            redirectionUrl = 'documents/training-documents';
          }
          else {
            redirectedFromTo = 'Login-Collaboration';
            redirectionUrl = url.includes('/documents/') ? url.substring(1) : 'documents/cisco-documents';
          }
        }
        else if (url === '/' || url.startsWith('/callback')) {
          if (this.loggedInUser.role.value === 'supplier_commodity_manager_sucm') {
            redirectedFromTo = 'Login-Sucm';
          }
          else if (this.loggedInUser.role.value === 'sourcing_commodity_manager_socm') {
            redirectedFromTo = 'Login-Socm';
          }
          else if (this.loggedInUser.role.value === 'commodity_directors') {
            redirectedFromTo = 'Login-Director';
          }

          if (this.isUserRestricted) {
            redirectionUrl = 'sucm-new-home';
          }
          else {
            redirectionUrl = this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' || this.loggedInUser.role.value === 'sourcing_commodity_manager_socm' ? 'sucm-new-home' : 'sucm-home/my-view';
          }
        }
        else if (mainTabName) {
          redirectedFromTo = 'Login-' + mainTabName;
          redirectionUrl = redirection;
        }
        else {
          if (this.loggedInUser.role.value === 'supplier_commodity_manager_sucm') {
            redirectedFromTo = 'Login-Sucm';
          }
          else if (this.loggedInUser.role.value === 'sourcing_commodity_manager_socm') {
            redirectedFromTo = 'Login-Socm';
          }
          else if (this.loggedInUser.role.value === 'commodity_directors') {
            redirectedFromTo = 'Login-Director';
          }
          redirectionUrl = this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' || this.loggedInUser.role.value === 'sourcing_commodity_manager_socm' ? 'sucm-new-home' : 'sucm-home/my-view';
        }
      }
      else if (this.loggedInUser.role.value === 'gsm_general_user_okta'
        || (this.loggedInUser.role.value === 'supply_chain_view_access' && !this.isSocmRestricted)) {
        await this.initializeFilterList();
        if (url.includes('incident-management') && parts[2] && parts[3]) {
          await this.applyIncidentDeepLinkContext(parts);
          redirectedFromTo = 'Login-Collaboration';
          redirectionUrl = 'incident-management';
        }
        else if (url === '/fhr-tracker') {
          redirectionUrl = 'fhr-tracker/supplier-view/all-suppliers';
          redirectedFromTo = 'Login-Collaboration';
        }
        else if (url.includes('/documents')) {
          if (url.includes('/documents/training-documents')) {
            redirectedFromTo = 'Login-Collaboration';
            redirectionUrl = 'documents/training-documents';
          }
          else {
            redirectedFromTo = 'Login-Collaboration';
            redirectionUrl = url.includes('/documents/') ? url.substring(1) : 'documents/cisco-documents';
          }
        }
        else if (url.includes('/supplier-whitepaper')) {
          redirectedFromTo = 'Login-Collaboration';
          redirectionUrl = this.resolveWhitepaperRedirectionUrl(url, this.loggedInUser?.userId === 'mdemarti' ? 'supplier-whitepaper/published-whitepapers' : 'supplier-whitepaper/active-whitepapers');
        }
        else {
          redirectedFromTo = this.loggedInUser.role.value === 'supply_chain_view_access'
            ? 'Login-Sco'
            : 'Login-General';
          redirectionUrl = 'general-user-home';
        }
      }

      if (redirectedFromTo && redirectionUrl) {
        window.localStorage.setItem('redirectedFrom-To', redirectedFromTo);
        this.sharedService.setRedirectionUrl(redirectionUrl);
      }
      window.localStorage.removeItem('type');
    }
  }

  async checkIfUserAccessIsRestricted() {
    this.isUserRestricted = true;
    this.hideSectionsForSocm = true;
    this.isSocmRestricted = false;

    let lookupType = this.loggedInUser.role.value === 'supply_chain_view_access'
      ? 'SCO_USER_EXTENDED_ACCESS' : 'SCW_SUCM_ACCESS_USERS';
    let localKey = this.loggedInUser.role.value === 'supply_chain_view_access' ? 'restrictedAccessUsers' : 'sucmPageAccessUsers';
    let usersList: any = [];
    if (window.localStorage.getItem(localKey)) {
      usersList = JSON.parse(this.encDecSrvice.get(window.localStorage.getItem(localKey)));
    }
    else {
      this.loaderService.openLoader();
      const respData: any = await lastValueFrom(this.lookupService.getDropdownLookup(lookupType))
        .catch((err: any) => {
          this.loaderService.closeLoader();
          this.openConfirmationPopup('Error', err.error.errorMsg, false);
        });
        this.loaderService.closeLoader();
      if (respData && respData.lookupArray && respData.lookupArray.length > 0) {
        usersList = respData.lookupArray;
        window.localStorage.setItem(localKey, this.encDecSrvice.set(JSON.stringify(respData.lookupArray)));
      }
    }

    if (usersList.length > 0) {
      let matchedUser: any = [];
      matchedUser = usersList.filter((u: any) => u.description === this.loggedInUser.email);
      if (matchedUser.length > 0) {
        if (this.loggedInUser.role.value === 'supply_chain_view_access') {
          if (matchedUser[0].enableFlag === 'Y') {
            this.hideSectionsForSocm = false;
          }
          else {
            this.isSocmRestricted = true;
          }
        }
        else {
          this.isUserRestricted = false;
        }
      }
    }
    window.localStorage.setItem('hideSectionsForSocm', `${this.hideSectionsForSocm}`);
  }

  async initializeFilterList() {
    this.loaderService.openLoader();
    try {
      const filterListResp: any = await lastValueFrom(this.cepmService.fetchAllSearchData())
        .catch((err: any) => {
          this.openConfirmationPopup('Error', err.error.errorMsg, false);
          return null;
        });
      if (filterListResp) {
        window.localStorage.setItem('filterListResp', JSON.stringify(filterListResp));
        this.getFilterList();
      }
    } finally {
      this.loaderService.closeLoader();
    }
  }

  getFilterList() {
    this.initializeFilterVariables();
    this.selectedSupplier = this.encDecSrvice.get(window.localStorage.getItem('supplierName'));
    this.isSupplierRestricted = JSON.parse(window.localStorage.getItem('isSupplierRestricted'));
    const selectedSucm: any = window.localStorage.getItem('selectedSucm');
    this.selectedSucm = (selectedSucm && selectedSucm.length) > 0 ? JSON.parse(window.localStorage.getItem('selectedSucm')) : [];
    const selectedCommodity: any = window.localStorage.getItem('selectedCommodities');
    this.selectedCommodity = (selectedCommodity && selectedCommodity.length > 0) ? JSON.parse(window.localStorage.getItem('selectedCommodities')) : [];
    if (this.selectedSupplier !== 'ALL') {
      this.supplierList = JSON.parse(window.localStorage.getItem('supplierList'));
      this.commodityList = JSON.parse(window.localStorage.getItem('commodityList'));
      this.sucmList = JSON.parse(window.localStorage.getItem('sucmList'));
    }
    else {
      const filterListRaw = window.localStorage.getItem('filterListResp');
      if (!filterListRaw) {
        return;
      }
      const filterListResp: any = JSON.parse(filterListRaw);
      if (!filterListResp?.supplier || !filterListResp?.commodity || !filterListResp?.sucm) {
        return;
      }
      this.supplierList = filterListResp.supplier;
      this.commodityList = filterListResp.commodity;
      this.sucmList = filterListResp.sucm;
      window.localStorage.setItem('supplierList', JSON.stringify(this.supplierList));
      window.localStorage.setItem('commodityList', JSON.stringify(this.commodityList));
      window.localStorage.setItem('sucmList', JSON.stringify(this.sucmList));
    }
    this.isAllCommoditiesSelected = this.selectedCommodity.length === this.commodityList.length ? true : false;
    this.isAllSucmSelected = this.selectedSucm.length === this.sucmList.length ? true : false;
  }

  async initializeTabs() {
    //sucm
    if (this.loggedInUser.role.value === 'supply_chain_view_access' || this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' || this.loggedInUser.role.value === 'sourcing_commodity_manager_socm' || this.loggedInUser.role.value === 'commodity_directors' || this.loggedInUser?.role?.value === 'gsm_general_user_okta' || this.loggedInUser?.role?.value === 'scw_admin') {
      this.mainTabs = [
        this.generateMainTab('AdminUser','Home', '/sucm-home/overall-view', this.loggedInUser.role.value === 'scw_admin' && this.selectedSupplier === 'ALL', ''),
        this.generateTabGroupsForAdminUser(),
        this.generateMainTab('Sucm','Home', '/sucm-new-home', this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' && this.selectedSupplier === 'ALL', ''),
        this.generateTabGroupsForSucmUser(),
        this.generateMainTab('Socm','Home', '/sucm-new-home', this.loggedInUser.role.value === 'sourcing_commodity_manager_socm' && this.selectedSupplier === 'ALL', ''),
        this.generateTabGroupsForSocmUser(),
        this.generateMainTab('Director','Home', this.isUserRestricted ? '/general-user-home' : '/sucm-home/my-view', this.loggedInUser.role.value === 'commodity_directors' && this.selectedSupplier === 'ALL', ''),
        this.generateTabGroupsForDirectorUser(),
        this.generateMainTab('Sco','Home', '/general-user-home', this.loggedInUser.role.value === 'supply_chain_view_access' && this.selectedSupplier === 'ALL', ''),
        this.generateTabGroupsForScoUser(),
        this.generateMainTab('General','Home', '/general-user-home', this.loggedInUser.role.value === 'gsm_general_user_okta' && this.selectedSupplier === 'ALL', ''),
        this.generateTabGroupsForGeneralUser(),
        this.generateAdminCollabTabGroupForGeneralUser((this.loggedInUser.role.value === 'gsm_general_user_okta' || this.loggedInUser.role.value === 'supply_chain_view_access') && this.selectedSupplier === 'ALL' ? 'Collaboration' : 'Admin',this.selectedSupplier === 'ALL' ? 'Collaboration' : 'Admin',(this.loggedInUser.role.value === 'gsm_general_user_okta' || this.loggedInUser.role.value === 'supply_chain_view_access') && this.selectedSupplier === 'ALL'),
        this.generateAdminCollabTabGroupForAdminUser((this.loggedInUser.role.value !== 'gsm_general_user_okta' && this.loggedInUser.role.value !== 'supply_chain_view_access') && this.selectedSupplier === 'ALL' ? 'Collaboration' : 'Admin',(this.selectedSupplier === 'ALL' && this.loggedInUser?.role?.value !== 'scw_admin') ? 'Collaboration' : 'Admin',(this.loggedInUser?.role?.value === 'scw_admin' || this.loggedInUser.role.value === 'commodity_directors' || this.loggedInUser.role.value === 'sourcing_commodity_manager_socm' || this.loggedInUser.role.value === 'supplier_commodity_manager_sucm') && this.selectedSupplier === 'ALL'),
        this.generateTabGroupsForPerformance(),
        this.generateTabGroupsForCollaboration(),
        this.generateMainTab('SC Apps', 'SC Apps', '', (this.loggedInUser?.role?.value === 'scw_admin' || this.loggedInUser.role.value === 'gsm_general_user_okta' || this.loggedInUser.role.value === 'supply_chain_view_access' || this.loggedInUser.role.value === 'commodity_directors' || this.loggedInUser.role.value === 'sourcing_commodity_manager_socm' || this.loggedInUser.role.value === 'supplier_commodity_manager_sucm') && this.selectedSupplier !== 'ALL', ''),
        this.generateTabGroupsForTraining(),
        this.generateMainTab('Report Issues', 'Report Issues', '/report-issues', this.loggedInUser?.role?.value === 'scw_admin' || this.loggedInUser.role.value === 'gsm_general_user_okta' || this.loggedInUser.role.value === 'supply_chain_view_access' || this.loggedInUser.role.value === 'commodity_directors' || this.loggedInUser.role.value === 'sourcing_commodity_manager_socm' || this.loggedInUser.role.value === 'supplier_commodity_manager_sucm', ''),
        this.generateMainTab('Contact Us', 'Contact Us', '/winodw-open', this.loggedInUser?.role?.value === 'scw_admin' || this.loggedInUser.role.value === 'gsm_general_user_okta' || this.loggedInUser.role.value === 'supply_chain_view_access' || this.loggedInUser.role.value === 'commodity_directors' || this.loggedInUser.role.value === 'sourcing_commodity_manager_socm' || this.loggedInUser.role.value === 'supplier_commodity_manager_sucm', ''),
        this.generateAdminCollabTabGroupForAdminUser((this.loggedInUser.role.value !== 'gsm_general_user_okta' && this.loggedInUser.role.value !== 'supply_chain_view_access') && this.selectedSupplier === 'ALL' ? 'Collaboration' : 'Admin2',(this.selectedSupplier === 'ALL' && this.loggedInUser?.role?.value !== 'scw_admin') ? 'Collaboration' : 'Admin',(this.loggedInUser?.role?.value === 'scw_admin' || this.loggedInUser.role.value === 'commodity_directors' || this.loggedInUser.role.value === 'sourcing_commodity_manager_socm' || this.loggedInUser.role.value === 'supplier_commodity_manager_sucm') && this.selectedSupplier !== 'ALL'),
        this.generateAdminCollabTabGroupForGeneralUser((this.loggedInUser.role.value === 'gsm_general_user_okta' || this.loggedInUser.role.value === 'supply_chain_view_access') && this.selectedSupplier === 'ALL' ? 'Collaboration' : 'Admin4',this.selectedSupplier === 'ALL' ? 'Collaboration' : 'Admin',(this.loggedInUser.role.value === 'gsm_general_user_okta' || this.loggedInUser.role.value === 'supply_chain_view_access') && this.selectedSupplier !== 'ALL'),
        this.generateMainTab('FAQsGeneral', 'FAQs', '/faq', this.loggedInUser.role.value === 'gsm_general_user_okta', ''),
        this.generateTabGroupsForFavorites(),
        this.generateMainTab('Watchlist', 'Watchlist', '/sucm-home/watchlist', (this.loggedInUser?.role?.value === 'supplier_commodity_manager_sucm' || this.loggedInUser?.role?.value === 'sourcing_commodity_manager_socm' || this.loggedInUser?.role?.value === 'commodity_directors' || this.loggedInUser?.role?.value === 'scw_admin') && this.selectedSupplier === 'ALL', ''),
        this.generateMainTab('Search Supplier', 'Search Supplier', '/search-supplier', this.loggedInUser?.role?.value === 'scw_admin' || this.loggedInUser.role.value === 'gsm_general_user_okta' || this.loggedInUser.role.value === 'supply_chain_view_access' || this.loggedInUser.role.value === 'commodity_directors' || this.loggedInUser.role.value === 'sourcing_commodity_manager_socm' || this.loggedInUser.role.value === 'supplier_commodity_manager_sucm', ''),
      ];
      this.breadcrumbs = this.generateBreadcrumbs(this.mainTabs);
    }
    else if (this.loggedInUser.role.value === 'scw_supplier_user') {
      this.getCrossChildVisibitySuppliers();
      this.mainTabs = [
        this.generateMainTab('Home', 'Home', '/supplier-new-home', this.loggedInUser.role.value === 'scw_supplier_user', ''),
        this.generateTabGroupsForPerformance(),
        this.generateTabGroupsForCollaboration(),
        this.generateMainTab('SC Apps', 'SC Apps', '', this.loggedInUser.role.value === 'scw_supplier_user', ''),
        this.generateTabGroupsForTraining(),
        this.generateMainTab('Report Issues', 'Report Issues', '/report-issues', this.loggedInUser.role.value === 'scw_supplier_user', ''),
        this.generateMainTab('Contact Us', 'Contact Us', '/winodw-open', this.loggedInUser.role.value === 'scw_supplier_user', '')
      ];
      this.breadcrumbs = this.generateBreadcrumbs(this.mainTabs);
    } 
    else {
      this.mainTabs = [
        {
          mainTabName: 'SCW Home',
          labelName: 'SCW Home',
          mainTabUrl: '',
          isMainTabVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL'
            || this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' || this.loggedInUser.role.value === 'commodity_directors' || this.loggedInUser.role.value === 'gsm_general_user_okta',
          mainTabTooltip: '',
          tabGroups: [
            {
              tabGroupName: 'SCW Home',
              tabGroupTooltip: '',
              tabGroupUrl: '',
              isTabGroupVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL'
                || this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' || this.loggedInUser.role.value === 'commodity_directors'
                || this.loggedInUser.role.value === 'gsm_general_user_okta',
              subTabs: [
                {
                  subTabName: 'Supplier Home',
                  subTabUrl: '/supplier-new-home',
                  isSubTabVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL',
                  subTabTooltip: ''
                },
                {
                  subTabName: 'Performance Scorecard',
                  subTabUrl: '/supplier-home',
                  isSubTabVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL',
                  subTabTooltip: ''
                },
                {
                  subTabName: (this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' || this.loggedInUser.role.value === 'commodity_directors') ? 'SUCM Home' : 'SOCM Home',
                  subTabUrl: '/sucm-home/my-view',
                  isSubTabVisible: (this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' || this.loggedInUser.role.value === 'commodity_directors') && !this.isUserRestricted,
                  subTabTooltip: ''
                },
                {
                  subTabName: (this.loggedInUser.role.value === 'gsm_general_user_okta' || this.loggedInUser.role.value === 'supply_chain_view_access') ? 'General User Home' : 'SUCM Home',
                  subTabUrl: '/general-user-home',
                  isSubTabVisible: this.loggedInUser.role.value === 'gsm_general_user_okta'
                    || (this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' && this.isUserRestricted)
                    || (this.loggedInUser.role.value === 'commodity_directors' && this.isUserRestricted)
                    || this.loggedInUser.role.value === 'supply_chain_view_access',
                  subTabTooltip: ''
                },
                {
                  subTabName: 'About Us',
                  subTabUrl: '/about-us',
                  isSubTabVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL',
                  subTabTooltip: ''
                },
                {
                  subTabName: 'FAQs',
                  subTabUrl: '/faq',
                  isSubTabVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL'
                    || this.loggedInUser.role.value === 'gsm_general_user_okta' || this.loggedInUser.role.value === 'supply_chain_view_access',
                  subTabTooltip: ''
                },
                {
                  subTabName: 'Download',
                  subTabUrl: '/download',
                  subTabTooltip: '',
                  isSubTabVisible: false
                }
              ]
            }
          ]
        },
        {
          mainTabName: 'Performance',
          labelName: 'Performance',
          mainTabUrl: '',
          isMainTabVisible: this.loggedInUser.role.value === 'scw_supplier_user' ||
            (((this.loggedInUser.role.value === 'supply_chain_view_access' && !this.hideSectionsForSocm)
              || this.loggedInUser.role.value !== 'supply_chain_view_access') && this.selectedSupplier !== 'ALL'),
          mainTabTooltip: '',
          tabGroups: [
            this.generateSubTabForSbrResiliencyScoreTabGroup(),
            {
              tabGroupName: 'QUALITY',
              tabGroupTooltip: '',
              tabGroupUrl: '',
              isTabGroupVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL',
              subTabs: [
                {
                  subTabName: 'QP/QR By Commodity',
                  subTabUrl: '/quality/qp-qr-by-commodity',
                  isSubTabVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL',
                  subTabTooltip: ''
                },
                {
                  subTabName: 'QP/QR Detailed View',
                  subTabUrl: '/quality/qp-qr-detailed-view',
                  isSubTabVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL',
                  subTabTooltip: ''
                },
                {
                  subTabName: 'Quality Cases',
                  subTabUrl: '/quality/quality-cases',
                  isSubTabVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL',
                  subTabTooltip: ''
                }
              ]
            },
            {
              tabGroupName: 'FULFILLMENT',
              tabGroupTooltip: '',
              tabGroupUrl: '',
              isTabGroupVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL',
              subTabs: [
                {
                  subTabName: 'CT2R and OTC',
                  subTabUrl: '/fulfillment/ct2r-and-otc',
                  isSubTabVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL',
                  subTabTooltip: ''
                },
                {
                  subTabName: 'Agility',
                  subTabUrl: '/fulfillment/agility',
                  isSubTabVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL',
                  subTabTooltip: ''
                }
              ]
            },
            this.generateSubTabsForSourcingMetricsTabGroup()
          ]
        },
        {
          mainTabName: 'Collaboration',
          labelName: 'Collaboration',
          mainTabUrl: '',
          isMainTabVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL',
          mainTabTooltip: '',
          tabGroups: (() => {
            const isSupplierOrSpecificSupplierSelected = this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL';
            return [
              {
                tabGroupName: 'SURVEYS/EVENTS',
                tabGroupUrl: '',
                isTabGroupVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' || this.loggedInUser.role.value === 'scw_admin',
                tabGroupTooltip: '',
                subTabs: [
                  {
                    subTabName: 'Questionnaire',
                    subTabUrl: '/questionnaire',
                    subTabTooltip: '',
                    isSubTabVisible: isSupplierOrSpecificSupplierSelected,
                  },
                  {
                    subTabName: 'Cisco Events Calendar',
                    subTabUrl: '/events/cisco-events',
                    subTabTooltip: '',
                    isSubTabVisible: isSupplierOrSpecificSupplierSelected,
                  },
                  {
                    subTabName: 'Supplier Events Calendar',
                    subTabUrl: '/events/supplier-events',
                    subTabTooltip: '',
                    isSubTabVisible: isSupplierOrSpecificSupplierSelected,
                  },
                  {
                    subTabName: 'Event Timeline Calendar',
                    subTabUrl: '/events/event-timeline',
                    subTabTooltip: '',
                    isSubTabVisible: isSupplierOrSpecificSupplierSelected,
                  },
                  //add the incident tracker code here
                  {
                    subTabName: 'Incident Tracker',
                    subTabUrl: '/incident-management',
                    isSubTabVisible: isSupplierOrSpecificSupplierSelected,
                    subTabTooltip: ''
                  },
                  {
                    subTabName: 'Incident Management',
                    subTabUrl: '/incident-management/' + this.dynamicSupplierName + '/' + this.dynamicSurveyId,
                    subTabTooltip: '',
                    isSubTabVisible: false
                  }
                ]
              },
              {
                tabGroupName: 'CONTACTS/PROFILE',
                tabGroupUrl: '',
                isTabGroupVisible: isSupplierOrSpecificSupplierSelected,
                tabGroupTooltip: '',
                subTabs: [
                  {
                    subTabName: 'Supplier Contacts',
                    subTabUrl: '/contact-management',
                    subTabTooltip: '',
                    isSubTabVisible: isSupplierOrSpecificSupplierSelected,
                  },
                  {
                    subTabName: 'My Company',
                    subTabUrl: '/supplier-profile',
                    subTabTooltip: '',
                    isSubTabVisible: (this.loggedInUser.role.value === 'scw_admin' || this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' || this.loggedInUser.role.value === 'commodity_directors')
                      && this.selectedSupplier !== 'ALL'
                  }
                ]
              },
              {
                tabGroupName: 'DOCUMENTS',
                tabGroupUrl: '',
                isTabGroupVisible: isSupplierOrSpecificSupplierSelected,
                tabGroupTooltip: '',
                subTabs: [
                  {
                    subTabName: 'Cisco Documents',
                    subTabUrl: '/documents/cisco-documents',
                    subTabTooltip: '',
                    isSubTabVisible: isSupplierOrSpecificSupplierSelected,
                  },
                  {
                    subTabName: 'Supplier Documents',
                    subTabUrl: '/documents/supplier-documents',
                    subTabTooltip: '',
                    isSubTabVisible: isSupplierOrSpecificSupplierSelected,
                  }
                ]
              }
            ];
          })()
        },
        {
          mainTabName: 'Tools',
          labelName: 'Tools',
          mainTabUrl: '',
          isMainTabVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL',
          mainTabTooltip: '',
          tabGroups: []
        },
        {
          mainTabName: 'Training',
          labelName: 'Training',
          mainTabUrl: '',
          isMainTabVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL',
          mainTabTooltip: '',
          tabGroups: [
            {
              tabGroupName: '',
              tabGroupUrl: '',
              isTabGroupVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL',
              tabGroupTooltip: '',
              subTabs: [
                {
                  subTabName: 'Trainings',
                  subTabUrl: '/documents/training-documents',
                  subTabTooltip: '',
                  isSubTabVisible: this.loggedInUser.role.value === 'scw_supplier_user' || this.selectedSupplier !== 'ALL',
                }
              ]
            }
          ]
        },
        {
          mainTabName: 'Workbench',
          labelName: 'Workbench',
          mainTabUrl: '',
          isMainTabVisible: (((this.loggedInUser.role.value === 'supply_chain_view_access' && !this.hideSectionsForSocm)
            || this.loggedInUser.role.value === 'gsm_general_user_okta') && this.selectedSupplier !== 'ALL')
            || this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' || this.loggedInUser.role.value === 'sourcing_commodity_manager_socm'
            || this.loggedInUser.role.value === 'commodity_directors' || this.loggedInUser.role.value === 'scw_admin',
          mainTabTooltip: '',
          tabGroups: [
            {
              tabGroupName: 'WORKBENCH',
              tabGroupUrl: '',
              isTabGroupVisible: ((this.loggedInUser.role.value === 'supply_chain_view_access'
                || this.loggedInUser.role.value === 'gsm_general_user_okta') && this.selectedSupplier !== 'ALL')
                || this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' || this.loggedInUser.role.value === 'sourcing_commodity_manager_socm'
                || this.loggedInUser.role.value === 'commodity_directors' || this.loggedInUser.role.value === 'scw_admin',
              tabGroupTooltip: '',
              subTabs: [
                {
                  subTabName: 'Dashboards',
                  subTabUrl: '/dashboard',
                  subTabTooltip: '',
                  isSubTabVisible: ((this.loggedInUser.role.value === 'supply_chain_view_access'
                    || this.loggedInUser.role.value === 'gsm_general_user_okta') && this.selectedSupplier !== 'ALL')
                    || this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' || this.loggedInUser.role.value === 'sourcing_commodity_manager_socm'
                    || this.loggedInUser.role.value === 'commodity_directors' || this.loggedInUser.role.value === 'scw_admin'
                },
                {
                  subTabName: 'Messages',
                  subTabUrl: '/messages',
                  subTabTooltip: '',
                  isSubTabVisible: ((this.loggedInUser.role.value === 'supply_chain_view_access'
                    || this.loggedInUser.role.value === 'gsm_general_user_okta') && this.selectedSupplier !== 'ALL')
                    || this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' || this.loggedInUser.role.value === 'sourcing_commodity_manager_socm'
                    || this.loggedInUser.role.value === 'commodity_directors' || this.loggedInUser.role.value === 'scw_admin'
                },
                {
                  subTabName: 'Wizards',
                  subTabUrl: '/wizards',
                  subTabTooltip: '',
                  isSubTabVisible: this.loggedInUser.role.value !== 'supply_chain_view_access'
                    && this.loggedInUser.role.value !== 'gsm_general_user_okta'
                }
              ]
            }
          ]
        },
        {
          mainTabName: 'Admin',
          labelName: 'Admin',
          mainTabUrl: '',
          isMainTabVisible: this.loggedInUser.role.value !== 'scw_supplier_user',
          mainTabTooltip: '',
          tabGroups: [
            {
              tabGroupName: 'ADMIN',
              tabGroupUrl: '',
              isTabGroupVisible: this.loggedInUser.role.value !== 'scw_supplier_user',
              tabGroupTooltip: '',
              subTabs: [
                {
                  subTabName: 'Lookup',
                  subTabUrl: '/lookup',
                  subTabTooltip: '',
                  isSubTabVisible: this.loggedInUser.role.value === 'scw_admin'
                },
                {
                  subTabName: 'Tools',
                  subTabUrl: '/tools',
                  subTabTooltip: '',
                  isSubTabVisible: this.loggedInUser.role.value !== 'scw_supplier_user',
                },
                {
                  subTabName: 'Questionnaire',
                  subTabUrl: '/questionnaire',
                  subTabTooltip: '',
                  isSubTabVisible: this.loggedInUser.role.value !== 'scw_supplier_user',
                },
                {
                  subTabName: 'Contact Management',
                  subTabUrl: '/contact-management',
                  subTabTooltip: '',
                  isSubTabVisible: this.loggedInUser.role.value !== 'scw_supplier_user',
                },
                {
                  subTabName: 'Events Calendar',
                  subTabUrl: '/events/cisco-events',
                  subTabTooltip: '',
                  isSubTabVisible: this.loggedInUser.role.value !== 'scw_supplier_user',
                },
                {
                  subTabName: 'Configuration Console',
                  subTabUrl: '/configuration-console',
                  subTabTooltip: '',
                  isSubTabVisible: this.loggedInUser.role.value === 'scw_admin'
                },               
                {
                  subTabName: 'Documents',
                  subTabUrl: '/documents/cisco-documents',
                  subTabTooltip: '',
                  isSubTabVisible: this.loggedInUser.role.value !== 'scw_supplier_user',
                },
                {
                  subTabName: 'Trainings',
                  subTabUrl: '/documents/training-documents',
                  subTabTooltip: '',
                  isSubTabVisible: this.loggedInUser.role.value !== 'scw_supplier_user'
                },
                {
                  subTabName: 'SuCM Overview',
                  subTabUrl: '/sucm-home/overall-view',
                  subTabTooltip: '',
                  isSubTabVisible: this.loggedInUser.role.value === 'scw_admin' || this.loggedInUser.role.value === 'sourcing_commodity_manager_socm'
                    || ((this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' || this.loggedInUser.role.value === 'commodity_directors') && !this.isUserRestricted)
                },
                {
                  subTabName: 'Supplier Whitepaper',
                  subTabUrl: this.loggedInUser.userId === 'mdemarti' ? '/supplier-whitepaper/published-whitepapers' : '/supplier-whitepaper/active-whitepapers',
                  subTabTooltip: '',
                  isSubTabVisible: this.isWhitepaperAccess
                },
                {
                  subTabName: 'Watchlist',
                  subTabUrl: '/sucm-home/watchlist',
                  subTabTooltip: '',
                  isSubTabVisible: this.loggedInUser.role.value === 'scw_admin' || this.loggedInUser.role.value === 'sourcing_commodity_manager_socm'
                    || ((this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' || this.loggedInUser.role.value === 'commodity_directors') && !this.isUserRestricted)
                },
                {
                  subTabName: 'Incident Management',
                  subTabUrl: '/incident-management',
                  subTabTooltip: '',
                  isSubTabVisible: false
                },
                {
                  subTabName: 'Download',
                  subTabUrl: '/download',
                  subTabTooltip: '',
                  isSubTabVisible: false
                }
              ]
            }
          ]
        },
      ];
    }

    await this.getTools();
    await this.getToolTips();
    this.loadFavorites();
  }

  // Supplier name prefix constants
  private readonly SPEND_PREFIX = '$ ';
  private readonly RESTRICTED_PREFIX = '! ';

  getUserRole() {
    let isAdmin = this.loggedInUser?.role?.value === 'scw_admin';
    let isGsmGeneralUser = this.loggedInUser?.role?.value === 'gsm_general_user_okta';
    let isSupplyChainViewAccess = this.loggedInUser?.role?.value === 'supply_chain_view_access';
    let isCommodityDirectors = this.loggedInUser?.role?.value === 'commodity_directors';
    let isSourcingCommodityManagerSocm = this.loggedInUser?.role?.value === 'sourcing_commodity_manager_socm';
    let isSupplierCommodityManagerSucm = this.loggedInUser?.role?.value === 'supplier_commodity_manager_sucm';
    let isSupplier = this.loggedInUser?.role?.value === 'scw_supplier_user';
    return { isAdmin, isGsmGeneralUser, isSupplyChainViewAccess, isCommodityDirectors, isSourcingCommodityManagerSocm, isSupplierCommodityManagerSucm, isSupplier };
  }

  // Helper method to check general user or supply chain view access roles
  private isGeneralOrSupplyChainUser(userRoles: any): boolean {
    return userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess;
  }

  // Helper method to check admin-level roles
  private isAdminLevelUser(userRoles: any): boolean {
    return userRoles.isAdmin || userRoles.isCommodityDirectors || 
           userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm;
  }

  // Helper method to check if supplier has a specific prefix
  private hasSupplierPrefix(supplierName: string, prefix: string): boolean {
    return supplierName.startsWith(prefix);
  }

  // Helper method to remove supplier prefix
  private removeSupplierPrefix(supplierName: string, prefix: string): string {
    return supplierName.replace(prefix, '').trim();
  }

  // Helper method to get clean supplier name
  private getCleanSupplierName(supplierName: string): string {
    if (this.hasSupplierPrefix(supplierName, this.SPEND_PREFIX)) {
      return this.removeSupplierPrefix(supplierName, this.SPEND_PREFIX);
    } else if (this.hasSupplierPrefix(supplierName, this.RESTRICTED_PREFIX)) {
      return this.removeSupplierPrefix(supplierName, this.RESTRICTED_PREFIX);
    }
    return supplierName.trim();
  }

  // Consolidated method to generate home tab groups for different user types
  private generateHomeTabGroupsForUser(config: {
    tabName: string;
    labelName: string;
    isVisible: boolean;
    homeUrl: string;
  }) {
    const mainTab = this.generateMainTab(config.tabName, config.labelName, '', config.isVisible, '');
    mainTab.tabGroups = [
      this.generateTabGroups('', '', config.isVisible, '', [
        this.generateSubTab('Home', config.homeUrl, config.isVisible, ''),
        this.generateSubTab('Supplier Home', '/supplier-new-home', config.isVisible, '')
      ])
    ];
    return mainTab;
  }

  generateTabGroupsForAdminUser() {
    const userRoles = this.getUserRole();
    return this.generateHomeTabGroupsForUser({
      tabName: 'AdminUser Supplier',
      labelName: 'Home',
      isVisible: userRoles.isAdmin && this.selectedSupplier !== 'ALL',
      homeUrl: '/sucm-home/overall-view'
    });
  }

  generateTabGroupsForSucmUser() {
    const userRoles = this.getUserRole();
    return this.generateHomeTabGroupsForUser({
      tabName: 'Sucm Supplier',
      labelName: 'Home',
      isVisible: userRoles.isSupplierCommodityManagerSucm && this.selectedSupplier !== 'ALL',
      homeUrl: '/sucm-new-home'
    });
  }

  generateTabGroupsForSocmUser() {
    const userRoles = this.getUserRole();
    return this.generateHomeTabGroupsForUser({
      tabName: 'Socm Supplier',
      labelName: 'Home',
      isVisible: userRoles.isSourcingCommodityManagerSocm && this.selectedSupplier !== 'ALL',
      homeUrl:  '/sucm-new-home'
    });
  }

  generateTabGroupsForDirectorUser() {
    const userRoles = this.getUserRole();
    return this.generateHomeTabGroupsForUser({
      tabName: 'Director Supplier',
      labelName: 'Home',
      isVisible: userRoles.isCommodityDirectors && this.selectedSupplier !== 'ALL',
      homeUrl: '/sucm-home/my-view'
    });
  }

  generateTabGroupsForGeneralUser() {
    const userRoles = this.getUserRole();
    return this.generateHomeTabGroupsForUser({
      tabName: 'General Supplier',
      labelName: 'Home',
      isVisible: userRoles.isGsmGeneralUser && this.selectedSupplier !== 'ALL',
      homeUrl: '/general-user-home'
    });
  }

  generateTabGroupsForScoUser() {
    const userRoles = this.getUserRole();
    return this.generateHomeTabGroupsForUser({
      tabName: 'Sco Supplier',
      labelName: 'Home',
      isVisible: userRoles.isSupplyChainViewAccess && this.selectedSupplier !== 'ALL',
      homeUrl: '/general-user-home'
    });
  }

  // Consolidated method to generate admin collaboration tab groups
  private generateAdminCollabTabGroups(config: {
    tabName: string;
    labelName: string;
    isMainTabVisible: boolean;
    isAdminLevel: boolean;
    userRoles: any;
  }) {
    const mainTab = this.generateMainTab(config.tabName, config.labelName, '', config.isMainTabVisible, '');
    const visibility = config.isAdminLevel ? 
      this.isAdminLevelUser(config.userRoles) : 
      this.isGeneralOrSupplyChainUser(config.userRoles);
    
    if (config.isAdminLevel) {
      mainTab.tabGroups = [
        this.generateTabGroups('', '', visibility, '', [
          this.generateSubTab('SuCM Overview', '/sucm-home/overall-view', visibility, ''),
          this.generateSubTab('Contact Management', '/contact-management', visibility, ''),
          // this.generateSubTab('Audit Board', '/audit-board', config.userRoles.isAdmin, ''),
          this.generateSubTab('SBR/EBR Module', '/sbr-planning', visibility, ''),
          this.generateSubTab('Incident Tracker', '/incident-management', visibility, ''),
          this.generateSubTab('Supplier Whitepaper', this.loggedInUser.userId === 'mdemarti' || (this.loggedInUser.role.value === 'commodity_directors' && this.loggedInUser.isGsmEmployee === 'Y') ? '/supplier-whitepaper/published-whitepapers' : '/supplier-whitepaper/active-whitepapers', visibility && this.isWhitepaperAccess, ''),
          this.generateSubTab('Parent Supplier Mapping', '/configuration-console', visibility, ''),
          this.generateSubTab('FHR Tracker', config.userRoles.isAdmin ? '/fhr-tracker/current-mapping' : '/fhr-tracker/supplier-view', visibility, '')
        ]),
        this.generateTabGroups('', '', visibility, '', [
          this.generateSubTab('Questionnaire', '/questionnaire', visibility, ''),
          this.generateSubTab('Messages', '/messages', visibility, ''),
          this.generateSubTab('Documents', '/documents/cisco-documents', visibility, ''),
          this.generateSubTab('Trainings', '/documents/training-documents', visibility, ''),
          this.generateSubTab('Events Calendar', '/events/cisco-events', visibility, ''),
          this.generateSubTab('Dashboards', '/dashboard', visibility, ''),
          this.generateSubTab('Wizards', '/wizards', visibility, '')
        ]),
        this.generateTabGroups('', '', visibility, '', [
          this.generateSubTab('Adoption Metrics', '/adoption-metrics', false, ''),
          this.generateSubTab('Data Refresh Status', '/data-refresh', visibility, ''),
          this.generateSubTab('Configuration Console', '/configuration-console', visibility, ''),
          this.generateSubTab('Lookup', '/lookup', config.userRoles.isAdmin, ''),
          this.generateSubTab('SC Apps', '/tools', visibility, '')
        ])
      ];
    } else {
      mainTab.tabGroups = [
        this.generateTabGroups('', '', visibility, '', [
          this.generateSubTab('Contact Management', '/contact-management', visibility, ''),
          this.generateSubTab('SBR/EBR Module', '/sbr-planning', visibility, ''),
          this.generateSubTab('Incident Tracker', '/incident-management', visibility, ''),
          this.generateSubTab('Supplier Whitepaper', this.loggedInUser.userId === 'mdemarti' ? '/supplier-whitepaper/published-whitepapers' : '/supplier-whitepaper/active-whitepapers', visibility && this.isWhitepaperAccess, ''),
          this.generateSubTab('Parent Supplier Mapping', '/configuration-console', visibility, ''),
          this.generateSubTab('FHR Tracker', '/fhr-tracker/supplier-view/all-suppliers', config.userRoles.isGsmGeneralUser || (config.userRoles.isSupplyChainViewAccess && this.hasFhrTrackerAccess), '')
        ]),
        this.generateTabGroups('', '', visibility, '', [
          this.generateSubTab('Questionnaire', '/questionnaire', visibility, ''),
          this.generateSubTab('Messages', '/messages', visibility, ''),
          this.generateSubTab('Documents', '/documents/cisco-documents', visibility, ''),
          this.generateSubTab('Trainings', '/documents/training-documents', visibility, ''),
          this.generateSubTab('Events Calendar', '/events/cisco-events', visibility, ''),
          this.generateSubTab('Configuration Console', '/configuration-console', visibility, ''),
          this.generateSubTab('SC Apps', '/tools', visibility, '')
        ])
      ];
    }
    return mainTab;
  }

  generateAdminCollabTabGroupForGeneralUser(tabName, labelName, isMainTabVisible) {
    const userRoles = this.getUserRole();
    return this.generateAdminCollabTabGroups({
      tabName,
      labelName,
      isMainTabVisible,
      isAdminLevel: false,
      userRoles
    });
  }

  generateAdminCollabTabGroupForAdminUser(tabName, labelName, isMainTabVisible) {
    const userRoles = this.getUserRole();
    return this.generateAdminCollabTabGroups({
      tabName,
      labelName,
      isMainTabVisible,
      isAdminLevel: true,
      userRoles
    });
  }

  generateTabGroupsForFavorites() {
    const userRoles = this.getUserRole();
    const mainTab = this.generateMainTab('Favorites', 'Favorites', '', !userRoles.isSupplier, '');
    mainTab.tabGroups = [
      this.generateTabGroups('', '', true, '', [])
    ];
    return mainTab;
  }

  generateTabGroupsForPerformance() {
    const userRoles = this.getUserRole();
    const mainTab = this.generateMainTab('Performance', 'Performance', '', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, '');
    mainTab.tabGroups = [
      this.generateSubTabForSbrResiliencyScoreTabGroup(),
      this.generateSubTabForQualityTabGroup(),
      this.generateSubTabsForFulfillmentTabGroup(),
      this.generateSubTabsForSourcingMetricsTabGroup(),
      this.generateSubTabsForPerformanceScoreCardTabGroup()
    ];
    return mainTab;
  }

  generateTabGroupsForCollaboration() {
    const userRoles = this.getUserRole();
    const mainTab = this.generateMainTab('Collaboration', 'Collaboration', '', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, '');
    mainTab.tabGroups = [
      this.generateSubTabsForQuestionnaireTabGroup(),
      this.generateSubTabsForDocumentsTabGroup(),
      this.generateSubTabsForEventsTabGroup()
    ];
    return mainTab;
  }

  generateTabGroupsForTraining() {
    const userRoles = this.getUserRole();
    const mainTab = this.generateMainTab('Training', 'Training', '', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, '');
    mainTab.tabGroups = [
      this.generateSubTabsForTrainingsTabGroup()
    ];
    return mainTab;
  }

  generateTabForSwitchCompany() {
    const userRoles = this.getUserRole();
    const mainTab = this.generateMainTab('Switch Company', 'Switch Company', '', this.visibilitySupplierList.length > 0 && userRoles.isSupplier, '');
    let subTabs: any = [
      this.generateSubTab(this.loggedInUser?.mcoCompany?.split('-RFQ')[0], '/supplier-new-home', mainTab.isMainTabVisible, '')
    ];
    this.visibilitySupplierList.map(supplier => {
      subTabs.push(this.generateSubTab(supplier, '/supplier-new-home', mainTab.isMainTabVisible, ''));
    });
    mainTab.tabGroups = [
      this.generateTabGroups('', '', mainTab.isMainTabVisible, '', subTabs)
    ];
    return mainTab;
  }

  generateSubTabForSbrResiliencyScoreTabGroup() {
    const userRoles = this.getUserRole();
    const tabGrp = this.generateTabGroups('SBR/RESILIENCY', '', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, '', []);
    tabGrp.subTabs = [
      this.generateSubTab('SBR Scorecard', '/sbr-score-card', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, ''),
      this.generateSubTab('Resiliency Scorecard', '/resiliency-score-card', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, ''),
      // TODO: ESG (Sustainability) Metrics temporarily disabled
      // this.generateSubTab('ESG (Sustainability) Metrics', '/supplier-sustainability-score', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, ''),
      this.generateSubTab('FHR : Financial Health Rating', '/fhr-detailed-view', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, '')
    ]
    return tabGrp;
  }

  generateSubTabForQualityTabGroup() {
    const userRoles = this.getUserRole();
    const tabGrp = this.generateTabGroups('QUALITY', '', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, '', []);
    tabGrp.subTabs = [
      this.generateSubTab('QP', '/quality/qp-qr-by-commodity', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, ''),
      this.generateSubTab('QR', '/quality/qp-qr-by-commodity', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, ''),
      this.generateSubTab('Quality Cases', '/quality/quality-cases', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, '')
    ]
    return tabGrp;
  }

  generateSubTabsForFulfillmentTabGroup() {
    const userRoles = this.getUserRole();
    const tabGrp = this.generateTabGroups('FULFILLMENT', '', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, '', []);
    tabGrp.subTabs = [
      this.generateSubTab('OTC', '/fulfillment/ct2r-and-otc', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, ''),
      this.generateSubTab('Del to CT2R', '/fulfillment/ct2r-and-otc', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, ''),
      this.generateSubTab('Agility', '/fulfillment/agility', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, '')
    ]
    return tabGrp;
  }

  generateSubTabsForSourcingMetricsTabGroup() {
    const userRoles = this.getUserRole();
    const tabGrp = this.generateTabGroups('SOURCING METRICS', '', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, '', []);
    tabGrp.subTabs = [
      this.generateSubTab('BAAO METRICS', '/baao-metrics', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, ''),
    ]
    return tabGrp;
  }

  generateSubTabsForPerformanceScoreCardTabGroup() {
    const userRoles = this.getUserRole();
    const tabGrp = this.generateTabGroups('PERFORMANCE SCORECARD', '', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, '', []);
    tabGrp.subTabs = [
      this.generateSubTab('PERFORMANCE SCORECARD', '/supplier-home', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, ''),
    ]
    return tabGrp;
  }

  generateSubTabsForQuestionnaireTabGroup() {
    const userRoles = this.getUserRole();
    const tabGrp = this.generateTabGroups('', '', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, '', []);
    tabGrp.subTabs = [
      this.generateSubTab('QUESTIONNAIRE', '/questionnaire', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, ''),
      // this.generateSubTab('AUDIT BOARD', '/audit-board', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, ''),
      this.generateSubTab('INCIDENT TRACKER', '/incident-management', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, ''),
      this.generateSubTab('CONTACTS', '/contact-management', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, ''),
      this.generateSubTab('MESSAGES', '/messages', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL'), '')
    ]
    return tabGrp;
  }

  generateSubTabsForDocumentsTabGroup() {
    const userRoles = this.getUserRole();
    const tabGrp = this.generateTabGroups('DOCUMENTS', '', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, '', []);
    tabGrp.subTabs = [
      this.generateSubTab('Cisco Documents', '/documents/cisco-documents', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, ''),
      this.generateSubTab('Supplier Documents', '/documents/supplier-documents', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, '')
    ]
    return tabGrp;
  }

  generateSubTabsForEventsTabGroup() {
    const userRoles = this.getUserRole();
    const tabGrp = this.generateTabGroups('EVENTS', '', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, '', []);
    tabGrp.subTabs = [
      this.generateSubTab('Cisco Events', '/events/cisco-events', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, ''),
      this.generateSubTab('Supplier Events', '/events/supplier-events', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, '')
    ]
    return tabGrp;
  }

  generateSubTabsForTrainingsTabGroup() {
    const userRoles = this.getUserRole();
    const tabGrp = this.generateTabGroups('', '', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, '', []);
    tabGrp.subTabs = [
      this.generateSubTab('Trainings', '/documents/training-documents', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, ''),
      this.generateSubTab('FAQ', '/faq', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, ''),
      this.generateSubTab('About SCW', '/about-us', ((userRoles.isAdmin || userRoles.isGsmGeneralUser || userRoles.isSupplyChainViewAccess || userRoles.isCommodityDirectors || userRoles.isSourcingCommodityManagerSocm || userRoles.isSupplierCommodityManagerSucm) && this.selectedSupplier !== 'ALL') || userRoles.isSupplier, '')
    ]
    return tabGrp;
  }

  generateMainTab(mTabName: any, labelName: any, mTabUrl: any, isMTabVisible: any, mTabTooltip: any) {
    return {
      mainTabName: mTabName,
      labelName: labelName,
      mainTabUrl: mTabUrl,
      isMainTabVisible: isMTabVisible,
      mainTabTooltip: mTabTooltip,
      tabGroups: []
    }
  }

  generateTabGroups(tabGroupName: any, tabGrpUrl: any, isTabGroupVisible: any, tabGrpTooltip: any, subTabs: any) {
    return {
      tabGroupName: tabGroupName,
      tabGroupTooltip: tabGrpTooltip,
      tabGroupUrl: tabGrpUrl,
      isTabGroupVisible: isTabGroupVisible,
      subTabs: subTabs
    }
  }

  generateSubTab(subTabName: any, subTabUrl: any, isSubTabVisible: any, subTabTooltip: any) {
    return {
      subTabName: subTabName,
      subTabUrl: subTabUrl,
      isSubTabVisible: isSubTabVisible,
      subTabTooltip: subTabTooltip
    };
  }

  getMainTabNameByUrl(subTabUrl: string): string {
    let mainTabName: string = '';

    this.mainTabs.some(mainTab => {
      return mainTab.tabGroups.some(tabGroup => {
        const subTab = tabGroup.subTabs.find(tab => tab.subTabUrl === subTabUrl);

        if (subTab) {
          mainTabName = mainTab.mainTabName;
          return true;
        }

        return false;
      });
    });

    return mainTabName;
  }

  onClickFilterPanel(val: any) {

    if (val === 'open') {
      this.loaderService.openLoader();

      this.initializeFilterVariables();
      window.localStorage.setItem('selectedSucm', JSON.stringify(this.selectedSucm));
      window.localStorage.setItem('selectedCommodities', JSON.stringify(this.selectedCommodity));
      this.isSupplierRestricted = JSON.parse(window.localStorage.getItem('isSupplierRestricted'));
      const selectedSucm: any = window.localStorage.getItem('selectedSucm');
      this.selectedSucm = (selectedSucm && selectedSucm.length) > 0 ? JSON.parse(window.localStorage.getItem('selectedSucm')) : [];
      const selectedCommodity: any = window.localStorage.getItem('selectedCommodities');
      this.selectedCommodity = (selectedCommodity && selectedCommodity.length > 0) ? JSON.parse(window.localStorage.getItem('selectedCommodities')) : [];

      const filterListResp: any = JSON.parse(window.localStorage.getItem('filterListResp'));
      this.supplierList = filterListResp.supplier;
      this.commodityList = filterListResp.commodity;
      this.sucmList = filterListResp.sucm;
      this.sortSupplierType = '';
      window.localStorage.setItem('supplierList', JSON.stringify(this.supplierList));
      window.localStorage.setItem('commodityList', JSON.stringify(this.commodityList));
      window.localStorage.setItem('sucmList', JSON.stringify(this.sucmList));

      this.isAllCommoditiesSelected = this.selectedCommodity.length === this.commodityList.length ? true : false;
      this.isAllSucmSelected = this.selectedSucm.length === this.sucmList.length ? true : false;
      this.loaderService.closeLoader();

    }
    this.isFilterOpened = val === 'open' ? true : false;
  }

  async onClickMainMenuBreadCrum(mainTab) {
    if (mainTab?.label == this.loggedInUser?.mcoCompany?.split('-RFQ')[0]) {
      await this.onSelectSupplier({supplierName : mainTab?.label});
    }
    else {
    window.localStorage.setItem('type', 'login');
    window.sessionStorage.setItem('selectedMainMenuIndex', this.selectedMainMenuIndex);
    this.selectedTabMenuGrpIndex = 0;
    window.sessionStorage.setItem('selectedTabMenuGrpIndex', this.selectedTabMenuGrpIndex);
    this.selectedSubMenuIndex = 0;
    window.sessionStorage.setItem('selectedSubMenuIndex', this.selectedSubMenuIndex);
    
    const roleRedirectMap: Record<string, { home: string; other: string }> = {
      supplier_commodity_manager_sucm: { home: 'Login-Sucm', other: 'Sucm-Sucm Supplier' },
      sourcing_commodity_manager_socm: { home: 'Login-Socm', other: 'Socm-Socm Supplier' },
      commodity_directors: { home: 'Login-Director', other: 'Director-Director Supplier' },
      supply_chain_view_access: { home: 'Login-Sco', other: 'Sco-Sco Supplier' },
      gsm_general_user_okta: { home: 'Login-General', other: 'General-General Supplier' },
      scw_admin: { home: 'Login-AdminUser', other: 'AdminUser-AdminUser Supplier' }
    };

    let redirectFromTo = '';
    let redirectionUrl = '';

    const role = this.loggedInUser.role.value;
    const isHome = mainTab?.label === 'Home';

    if (roleRedirectMap[role]) {
      redirectFromTo = isHome ? roleRedirectMap[role].home : roleRedirectMap[role].other;
      if (role === 'scw_admin') {
        redirectionUrl = isHome ? 'sucm-home/overall-view' : 'supplier-new-home';
      }
    } else {
      redirectFromTo = isHome ? 'Login-Home' : 'Admin-SCW Home';
    }

    if (mainTab?.label == 'Home') {
      this.breadcrumbs = [];
      this.breadcrumbs.push({ label: 'Home', url: this.isUserRestricted ? '/general-user-home' : '/sucm-home/my-view' });
      
      if(this.loggedInUser.role.value === 'scw_admin') {
        redirectionUrl = 'sucm-home/overall-view';
      }
      else if (this.loggedInUser.role.value === 'scw_supplier_user') {
        redirectionUrl = 'supplier-new-home';
      }
      else {
        redirectionUrl = this.isUserRestricted ? 'general-user-home' : 'sucm-home/my-view';
      }
    }
    else {
      redirectionUrl = 'supplier-new-home';
      window.localStorage.setItem('isFirstTimeSupplierSelected', 'true');
    }

    window.localStorage.setItem('redirectedFrom-To', redirectFromTo);
    this.sharedService.setRedirectionUrl(redirectionUrl);
    this.breadcrumbs = this.generateBreadcrumbs(this.mainTabs);
    this.onRemoveSupplierRecentVisit()
  }
  }

  onClickMainMenuTab(mainTab: any) {

    const mainMenuIndex = this.mainTabs.findIndex((mTab) => (mainTab.mainTabName === mTab.mainTabName) && (mainTab.labelName === mTab.labelName));

    if (mainTab?.mainTabUrl != '/winodw-open' && mainTab?.mainTabName != 'Search Supplier') {
      this.selectedMainMenuIndex = mainMenuIndex;
    }
    if (mainTab?.mainTabUrl == '/faq') {
      window.localStorage.setItem('faqMaintab', 'true');
    }

    if (mainTab?.labelName == 'Home') {
      let currentUrl = this.router.url;
      if (currentUrl === mainTab.mainTabUrl) {
        currentUrl = this.router.url.split('?')[0];
        this.router.navigate([currentUrl], {
          queryParams: { reload: Date.now() },
          queryParamsHandling: 'merge',
          skipLocationChange: true
        });
      }
      else {
        this.router.navigateByUrl('/').then(() => {
          this.router.navigate([mainTab.mainTabUrl]);
        });
      }
    }
    if (mainTab?.mainTabUrl == '/report-issues') {
      this.onClickReportIssues('open')
    }
    else if (mainTab?.mainTabUrl == '/search-supplier') {
      this.onClickFilterPanel(this.isFilterOpened ? 'close' : 'open')

    }
    else if (mainTab?.mainTabUrl == '/winodw-open') {
      const emailAddress = 'scw_support@cisco.com';
      const mailtoLink = `mailto:${emailAddress}`;
      window.location.href = mailtoLink;

    } else if (mainTab?.mainTabUrl == '/faq') {
      window.localStorage.setItem('faqMaintab', 'true');
      this.selectedMainMenuIndex = mainMenuIndex;
      window.sessionStorage.setItem('selectedMainMenuIndex', this.selectedMainMenuIndex);
      this.router.navigateByUrl('/').then(() => {
        this.router.navigate(['faq']);
      });
    } else if (mainTab?.mainTabUrl == '/sucm-home/watchlist') {
      this.selectedMainMenuIndex = mainMenuIndex;
      window.sessionStorage.setItem('selectedMainMenuIndex', this.selectedMainMenuIndex);
      this.router.navigateByUrl('/').then(() => {
        this.router.navigate(['sucm-home/watchlist']);
      });
    } else if (mainTab?.mainTabUrl == '/sucm-home/my-view') {
      window.sessionStorage.setItem('selectedMainMenuIndex', '0');
      window.sessionStorage.setItem('selectedTabMenuGrpIndex', '0');
      window.sessionStorage.setItem('selectedSubMenuIndex', '0');
      this.onRemoveSupplierRecentVisit();

      this.router.navigateByUrl('/').then(() => {
        this.router.navigate(['sucm-home/my-view']);
      });



    } else if (mainTab?.mainTabUrl == '/sucm-new-home') {
      window.sessionStorage.setItem('selectedMainMenuIndex', '0');
      window.sessionStorage.setItem('selectedTabMenuGrpIndex', '0');
      window.sessionStorage.setItem('selectedSubMenuIndex', '0');
      this.onRemoveSupplierRecentVisit();
      let currentUrl = this.router.url;

      this.router.navigateByUrl('/').then(() => {
        this.router.navigate(['sucm-new-home']);
      });



    } else if (mainTab?.mainTabUrl) {
      window.localStorage.setItem('type', 'login');
      window.sessionStorage.setItem('selectedMainMenuIndex', this.selectedMainMenuIndex);
      this.selectedTabMenuGrpIndex = 0;
      window.sessionStorage.setItem('selectedTabMenuGrpIndex', this.selectedTabMenuGrpIndex);
      this.selectedSubMenuIndex = 0;
      window.sessionStorage.setItem('selectedSubMenuIndex', this.selectedSubMenuIndex);
      if (mainTab?.labelName == 'Home') {
        this.onRemoveSupplierRecentVisit();
      }
      let currentUrl = this.router.url;
      if (currentUrl === mainTab.mainTabUrl) {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentUrl]);
        });
      }
      else {
        this.router.navigateByUrl('/').then(() => {
          this.router.navigate([mainTab.mainTabUrl]);
        });
      }
    }

    if (mainTab?.mainTabUrl == '/faq') {
      this.onClickFilterPanel('close');
    }

    this.breadcrumbs = this.generateBreadcrumbs(this.mainTabs);
    let obj = {
      mainTabName: mainTab.mainTabName,
      linkName: mainTab.mainTabName,
      linkUrl: mainTab.mainTabUrl
    }
    //this.addLink(obj);

  }

  async onClickSubMenuTab(mainTab: MainMenuTab, tabGroup: TabMenuGroup, subTab: SubMenuTabs) {
    window.localStorage.setItem('type', 'login');
    if (subTab.subTabName === 'Parent Supplier Mapping' && subTab.subTabUrl === '/configuration-console') {
      window.sessionStorage.setItem('configConsoleDefaultTo', 'parent-supplier-mapping');
    }
    if (subTab.subTabName === 'Configuration Console' && subTab.subTabUrl === '/configuration-console'
      && (this.loggedInUser?.role?.value === 'gsm_general_user_okta' || this.loggedInUser?.role?.value === 'supply_chain_view_access')) {
      window.sessionStorage.setItem('configConsoleRestricted', 'true');
    }
    if (subTab.subTabName === 'Adoption Metrics' && subTab.subTabUrl === '/adoption-metrics') {
      // Call the redirect function
      //this.redirectToSCWMetrics();
      window.open('https://tableau.cisco.com/#/site/SWSC/workbooks/124167/views', '_blank', 'noopener');

    } else if ((mainTab.mainTabName === 'Tools' || mainTab.mainTabName === 'SC Apps') && subTab.subTabName !== 'Tools : Detailed View') {
      this.addSplunkLog(subTab, 'verticalMenuExternalToolsNavigation');
      window.open(subTab.subTabUrl, '_blank', 'noopener');
    } else if (mainTab.mainTabName === 'Favorites') {
      // Handle Favorites tab navigation
      const matchingTab = this.findMatchingTabByUrl(subTab.subTabUrl);
      if (matchingTab) {
        this.navigateToTab(matchingTab.mainTab, matchingTab.tabGroup, matchingTab.subTab);
      }
    }
    else if (mainTab.mainTabName === 'Switch Company') {
      await this.onSelectSupplier({supplierName : subTab.subTabName});
    }
    else {
      this.selectedMainMenuIndex = this.mainTabs.findIndex((mTab) => (mainTab.mainTabName === mTab.mainTabName) && (mainTab.labelName === mTab.labelName));
      this.mainTabs[this.selectedMainMenuIndex].tabGroups.forEach((tabGrp, tGrpIndex) => {
        tabGrp.subTabs.forEach((sTab, sTabIndex) => {
          if (sTab.subTabName === subTab.subTabName) {
            this.selectedTabMenuGrpIndex = tGrpIndex;
            this.selectedSubMenuIndex = sTabIndex;
          }
        });
      });
      window.sessionStorage.setItem('selectedMainMenuIndex', this.selectedMainMenuIndex);
      window.sessionStorage.setItem('selectedTabMenuGrpIndex', this.selectedTabMenuGrpIndex);
      window.sessionStorage.setItem('selectedSubMenuIndex', this.selectedSubMenuIndex);

      const selectedSupplier = this.mainTabs[this.selectedMainMenuIndex].labelName === 'Admin' ?
        'ALL' : this.selectedSupplier;
      window.localStorage.setItem('selectedSupplier', this.encDecSrvice.set(selectedSupplier));
      window.sessionStorage.setItem('selectedSupplier', this.encDecSrvice.set(selectedSupplier));

      if ((mainTab.mainTabName === 'Tools' || mainTab.mainTabName === 'SC Apps') && subTab.subTabName === 'Tools : Detailed View') {
        this.addSplunkLog(subTab, 'supplierHomeToolsNavigation');
      }

      let currentUrl = this.router.url;
      const currentUrlBase = currentUrl.split('?')[0];
      if ((currentUrlBase === subTab.subTabUrl) || (currentUrlBase.split('/')[1] === subTab.subTabUrl.split('/')[1])) {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([subTab.subTabUrl]);
        });
      }
      else {
        this.router.navigateByUrl(subTab.subTabUrl);
      }
    }
    let obj = {
      mainTabName: mainTab.mainTabName,
      linkName: subTab.subTabName,
      linkUrl: subTab.subTabUrl,
      supplier: this.encDecSrvice.get(window.localStorage.getItem('selectedSupplier'))
    }
    this.addLink(obj);
    this.onClickFilterPanel('close');

    this.breadcrumbs = this.generateBreadcrumbs(this.mainTabs);
  }



  addSplunkLog(subTab: any, type: any) {
    const splunkToolsObj = {
      logType: type,
      supplierName: this.encDecSrvice.get(window.localStorage.getItem('selectedSupplier')),
      regionCode: window.localStorage.getItem('regionCode'),
      os: window.localStorage.getItem('os'),
      LocalTime: new Date(),
      countryCode: window.localStorage.getItem('countryCode'),
      ToolClicked: subTab.subTabName,
      emailId: this.loggedInUser.email,
      userId: this.loggedInUser.userId,
      continentCode: window.localStorage.getItem('continentCode'),
    };
    this.splunkLogsService.additionalLogs(splunkToolsObj).subscribe();
  }

  async getToolTips() {
    const toolTipsArr: any = window.localStorage.getItem('supplierTabToolTips');
    if (toolTipsArr && JSON.parse(toolTipsArr).length > 0) {
      this.showToolTipForSupplierTabs();
    }
    else {
      await lastValueFrom(this.dashboardService.getToolTipsDetails(this.loggedInUser.role.value))
        .then((respData: any) => {
          if (respData && respData.length > 0) {
            window.localStorage.setItem('supplierTabToolTips', JSON.stringify(respData));
            this.showToolTipForSupplierTabs();
          }
        })
        .catch((err: any) => {
          this.openConfirmationPopup('Error', err.error.errorMsg, false);
        });
    }
  }

  showToolTipForSupplierTabs() {
    const toolTipsArr: any = window.localStorage.getItem('supplierTabToolTips');
    if (toolTipsArr && JSON.parse(toolTipsArr).length > 0) {
      for (const mainTab of this.mainTabs) {
        if ((mainTab.mainTabName === 'Performance' || mainTab.mainTabName === 'Collaboration'
          || mainTab.mainTabName === 'Training' || mainTab.mainTabName === 'SCW Home') && (this.loggedInUser.role.value !== 'supplier_commodity_manager_sucm') && (this.loggedInUser.role.value !== 'commodity_directors')) {
          if (mainTab.tabGroups.length > 0) {
            for (const toolTip of JSON.parse(toolTipsArr)) {
              const tabGrp = mainTab.tabGroups.filter((tGrp) =>
                tGrp.tabGroupName.toLowerCase().trim() === toolTip.widgetName.toLowerCase().trim());
              if (tabGrp && tabGrp.length > 0) {
                tabGrp[0].tabGroupTooltip = toolTip.toolTip;
              }
              else {
                for (const tabGroup of mainTab.tabGroups) {
                  const subTab = tabGroup.subTabs.filter((sTab) =>
                    sTab.subTabName.toLowerCase().trim() === toolTip.widgetName.toLowerCase().trim());
                  if (subTab && subTab.length > 0) {
                    subTab[0].subTabTooltip = toolTip.toolTip;
                  }
                }
              }
            }
          }
          else {
            for (const toolTip of JSON.parse(toolTipsArr)) {
              if (toolTip.widgetName.toLowerCase() === this.mainTabs[this.selectedMainMenuIndex].mainTabName.toLowerCase()) {
                this.mainTabs[this.selectedMainMenuIndex].mainTabTooltip = toolTip.toolTip;
              }
            }
          }
        }
      }
    }
  }

  onClickInfoIcon(val: any, type?: any) {
    if (val === 'open') {
      this.readMeInfo = '';
      this.infoPopup = true;
      this.loaderService.openLoader();
      this.lookupService.getDropdownLookup('SCW_INFO_ICON_DATA').subscribe({
        next: (respData: any) => {
          this.loaderService.closeLoader();
          if (respData && respData.lookupArray && respData.lookupArray.length > 0) {
            if (type === 'filter-info') {
              this.readMeInfo = respData.lookupArray.filter((s: any) => s.code === 'FILTER PANEL')[0];
            }
            else {
              let lookupCode = '';
              if (this.router.url.includes('questionnaire') || this.router.url.includes('events')
                || this.router.url.includes('quality') || this.router.url.includes('fulfillment')
                || this.router.url.includes('dashboard') || this.router.url.includes('messages')
                || this.router.url.includes('wizards') || this.router.url.includes('tools')) {
                let val =  window.location.href.split('/')[3];
                lookupCode = val ? `${val.toUpperCase()} READ ME` : '';
              }
              else if (this.router.url.includes('supplier-profile') || this.router.url.includes('training-documents')
                || this.router.url.includes('sucm-home') || this.router.url.includes('fhr-detailed-view')) {
                let val = window.location.href.split('/')[3];
                val = val ? val.split('-').join(' ').toUpperCase() : '';
                lookupCode = val ? `${val} READ ME` : '';
              }
              else if (this.router.url.includes('sbr-score-card')) {
                lookupCode = 'SBR READ ME';
              }
              else if (this.router.url.includes('resiliency-score-card')) {
                lookupCode = 'RESILIENCY READ ME';
              }
              else if (this.router.url.includes('contact-management')) {
                lookupCode = 'CONTACTS READ ME';
              }
              else if (this.router.url.includes('cisco-documents') || this.router.url.includes('supplier-documents')) {
                lookupCode = 'DOCUMENTS READ ME';
              }
              else if (this.router.url.includes('baao-metrics')) {
                lookupCode = 'BAAO READ ME';
              }
              else if (this.router.url.includes('supplier-sustainability-score')) {
                lookupCode = 'SER READ ME';
              }
              if(lookupCode) {
                this.readMeInfo = respData.lookupArray.filter((s: any) => s.code.toUpperCase() === lookupCode)[0];
              }
            }
          }
        },
        error: (err: any) => {
          this.loaderService.closeLoader();
          this.openConfirmationPopup('Error', err.error.errorMsg, false);
        }
      });
    }
    else {
      this.infoPopup = false;
      this.readMeInfo = '';
    }
  }

  onClickLogout() {
    this.feedbackNotificationService.stop();
    window.localStorage.clear();
    this.isLoggedIn = false;
    this.networkService.navigateWhenOnline(['/logout']);
  }

  logout() {
   if (this.isRedirecting) {
    return;
  }

  this.feedbackNotificationService.stop();
  this.isRedirecting = true;
  window.localStorage.setItem('logout-event', 'logout');
  this.sharedService.logOut();
  
  // Reset redirect flag after navigation
  setTimeout(() => {
    this.isRedirecting = false;
  }, 2000);
  }

  initializeFilterVariables() {
    this.searchedSupplier = '';
    this.supplierList = [];
    this.filteredSupplierList = [];

    this.isAllCommoditiesSelected = false;
    this.selectedCommodity = [];
    this.commodityArr = [];
    this.commodityList = [];

    this.isAllSucmSelected = false;
    this.selectedSucm = [];
    this.sucmArr = [];
    this.sucmList = [];
  }

  changeForSpend(supplier: any) {
    return this.getCleanSupplierName(supplier.supplierName);
  }

  tooltipForRestrictedSupplier(supplier: any) {
    if (this.hasSupplierPrefix(supplier.supplierName, this.RESTRICTED_PREFIX)) {
      return `Restricted supplier -reach out to SUCM/SCW admin for more info`;
    }
  }

  showRestrictedFlag(supplier: any) {
    return this.hasSupplierPrefix(supplier.supplierName, this.RESTRICTED_PREFIX);
  }

  // Helper method to categorize suppliers by prefix
  private categorizeSuppliers(suppliers: any[]): {
    spend: string[];
    restricted: string[];
    normal: string[];
  } {
    const categories = { spend: [], restricted: [], normal: [] };
    
    suppliers.forEach((s: any) => {
      const name = s.supplierName;
      if (this.hasSupplierPrefix(name, this.SPEND_PREFIX)) {
        categories.spend.push(name.trim());
      } else if (this.hasSupplierPrefix(name, this.RESTRICTED_PREFIX)) {
        categories.restricted.push(name.trim());
      } else {
        categories.normal.push(name);
      }
    });
    
    return categories;
  }

  onChangeSortType(value: any) {
    this.sortSupplierType = value;
    this.supplierList = JSON.parse(window.localStorage.getItem('supplierList'));
    
    if (value === 'SortAlphabetically') {
      const categories = this.categorizeSuppliers(this.supplierList);
      const spendSorted = [...categories.spend].sort((a, b) => a.localeCompare(b));
      const restrictedSorted = [...categories.restricted].sort((a, b) => a.localeCompare(b));
      const sortedList = [
        ...spendSorted,
        ...restrictedSorted,
        ...categories.normal
      ];
      this.supplierList = sortedList.map(name => ({ supplierName: name }));
    }
  }

  // Helper method to determine supplier CSS class
  private getSupplierCssClass(supplierName: string): string {
    if (this.hasSupplierPrefix(supplierName, this.SPEND_PREFIX)) {
      return 'specialSupplier';
    } else if (this.hasSupplierPrefix(supplierName, this.RESTRICTED_PREFIX)) {
      return 'restrictedSupplier';
    }
    return 'normalSupplier';
  }

  applyClassForSupplier(supplier: any) {
    if (this.changeForSpend(supplier) === this.selectedSupplier.trim()) {
      return 'active-supplier';
    }
    return this.getSupplierCssClass(supplier.supplierName);
  }

  async onSelectSupplier(supplier: any, isRedirectedFromAnotherTab?: any) {
    window.localStorage.setItem('type', 'login');
    window.localStorage.removeItem('toolsList');
    this.isSupplierRestricted = false;
    if (supplier === 'ALL') {
      this.lastNewsInfoRequestKey = '';
      this.initializeFilterVariables();
      this.selectedSupplier = supplier;
      window.localStorage.removeItem('isFirstTimeSupplierSelected');
      window.localStorage.removeItem('isFirstTimeNewsPopupVisited');
      window.localStorage.removeItem('isFirstTimeNewsSectionVisited');
      window.localStorage.setItem('supplierName', this.encDecSrvice.set(this.selectedSupplier));
      window.localStorage.setItem('isSupplierRestricted', JSON.stringify(this.isSupplierRestricted));
      window.localStorage.setItem('selectedSupplier', this.encDecSrvice.set(this.selectedSupplier));
      window.sessionStorage.setItem('selectedSupplier', this.encDecSrvice.set(this.selectedSupplier));
      window.localStorage.setItem('selectedSucm', JSON.stringify(this.selectedSucm));
      window.localStorage.setItem('selectedCommodities', JSON.stringify(this.selectedCommodity));
      this.getFilterList();
      this.onChangeSortType('');
      if ((this.mainTabs[Number(window.sessionStorage.getItem('selectedMainMenuIndex'))].mainTabName === 'Admin'
        || this.mainTabs[Number(window.sessionStorage.getItem('selectedMainMenuIndex'))].mainTabName === 'AdminUser')
        && (this.loggedInUser.role.value !== 'supply_chain_view_access' && this.loggedInUser.role.value !== 'gsm_general_user_okta')) {
        this.selectedMainMenuIndex = Number(window.sessionStorage.getItem('selectedMainMenuIndex'));
        this.selectedTabMenuGrpIndex = Number(window.sessionStorage.getItem('selectedTabMenuGrpIndex'));
        this.selectedSubMenuIndex = Number(window.sessionStorage.getItem('selectedSubMenuIndex'));
        this.initializeTabs();
        let currentUrl = this.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentUrl]);
        });
      }
      else if (this.mainTabs[Number(window.sessionStorage.getItem('selectedMainMenuIndex'))].mainTabName !== 'Admin'
        && this.mainTabs[Number(window.sessionStorage.getItem('selectedMainMenuIndex'))].mainTabName !== 'AdminUser'
        && (this.loggedInUser.role.value === 'gsm_general_user_okta' || this.loggedInUser.role.value === 'supply_chain_view_access')) {
        this.initializeTabs();
        window.localStorage.setItem('redirectedFrom-To', 'Supplier-SCW Home');
        this.sharedService.setRedirectionUrl('general-user-home');
      }
      else if (this.mainTabs[Number(window.sessionStorage.getItem('selectedMainMenuIndex'))].mainTabName !== 'Admin'
        && this.mainTabs[Number(window.sessionStorage.getItem('selectedMainMenuIndex'))].mainTabName !== 'AdminUser'
        && (this.loggedInUser.role.value === 'supplier_commodity_manager_sucm' || this.loggedInUser.role.value === 'sourcing_commodity_manager_socm')) {
        this.initializeTabs();
        if (this.isUserRestricted) {
          window.localStorage.setItem('redirectedFrom-To', 'Supplier-SCW Home');
          this.sharedService.setRedirectionUrl('general-user-home');
        }
        else {
          if (this.loggedInUser.role.value === 'supplier_commodity_manager_sucm') {
            window.localStorage.setItem('redirectedFrom-To', 'Supplier-Sucm');
            this.sharedService.setRedirectionUrl('sucm-home/my-view');
          }

          if (this.loggedInUser.role.value === 'sourcing_commodity_manager_socm') {
            window.localStorage.setItem('redirectedFrom-To', 'Supplier-Socm');
            this.sharedService.setRedirectionUrl('general-user-home');
          }

        }
      }
      else {
        this.initializeTabs();
        window.localStorage.setItem('redirectedFrom-To', 'Supplier-AdminUser');
        this.sharedService.setRedirectionUrl('sucm-home/overall-view');
      }
    }
    else {
      this.onClickFilterPanel('close');
      let supplierName = supplier.supplierName;
      this.isSupplierRestricted = supplierName.indexOf('! ') === 0 ? true : false;
      supplierName = supplierName.indexOf('$ ') === 0 ? supplierName.replace('$ ', '').trim()
        : (supplierName.indexOf('! ') === 0 ? supplierName.replace('! ', '').trim() : supplierName.trim());
      this.selectedSupplier = supplierName;

      this.lastNewsInfoRequestKey = '';
      const selectedSupplier = this.mainTabs[Number(window.sessionStorage.getItem('selectedMainMenuIndex'))].labelName === 'Admin'
        && Number(window.sessionStorage.getItem('selectedMainMenuIndex')) != 13 ?
        'ALL' : this.selectedSupplier;
      if (selectedSupplier !== 'ALL') {
        window.localStorage.setItem('supplierName', this.encDecSrvice.set(this.selectedSupplier));
        window.localStorage.setItem('selectedSupplier', this.encDecSrvice.set(this.selectedSupplier));
        window.sessionStorage.setItem('selectedSupplier', this.encDecSrvice.set(this.selectedSupplier));
        window.localStorage.setItem('isFirstTimeNewsPopupVisited', 'true');
        window.localStorage.setItem('isFirstTimeNewsSectionVisited', 'true');
        window.localStorage.setItem('isSupplierRestricted', JSON.stringify(this.isSupplierRestricted));
        if(this.loggedInUser.role.value !== 'scw_supplier_user') {
          this.initializeTabs();
          await this.fetchDataBasedOnSearch('supplier', isRedirectedFromAnotherTab);
        }
        else {
          window.localStorage.setItem('redirectedFrom-To', 'Supplier-Home');
          this.sharedService.setRedirectionUrl('supplier-new-home');
        }
        //this.getNewsInfo();
      } else {
        window.localStorage.setItem('selectedSupplier', this.encDecSrvice.set(selectedSupplier));
        window.sessionStorage.setItem('selectedSupplier', this.encDecSrvice.set(selectedSupplier));
        window.localStorage.setItem('isFirstTimeSupplierSelected', 'false');
        this.initializeTabs();
        let currentUrl = this.router.url;
        // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        //         this.router.navigate([currentUrl]);
        //       });
        await this.fetchDataBasedOnSearch('supplier', false);

      }

    }
  }

  // Generic helper method for selectAll functionality
  private async handleSelectAll(
    event: any,
    itemList: any[],
    propertyName: string,
    storageKey: string,
    searchType: string
  ) {
    const arr: any[] = [];
    let selectedItems: any[] = [];

    if (event.checked) {
      itemList.forEach((item: any) => {
        selectedItems.push(item[propertyName]);
      });
    }

    setTimeout(async () => {
      if (searchType === 'sucm') {
        this.sucmArr = selectedItems;
        this.selectedSucm = selectedItems;
      } else {
        this.commodityArr = selectedItems;
        this.selectedCommodity = selectedItems;
      }
      window.localStorage.setItem(storageKey, JSON.stringify(selectedItems));
      await this.fetchDataBasedOnSearch(searchType);
    }, 100);
  }

  async onChangeSucm() {
    if (this.selectedSucm.indexOf('Select All') === -1) {
      this.isAllSucmSelected = false;
      this.sucmArr = this.selectedSucm;
      if (this.sucmList.length === this.sucmArr.length) {
        this.isAllSucmSelected = true;
      }
      window.localStorage.setItem('selectedSucm', JSON.stringify(this.selectedSucm));
      await this.fetchDataBasedOnSearch('sucm');
    }
  }

  async selectAllSucm(event: any) {
    this.sucmArr = [];
    this.selectedSucm = [];
    await this.handleSelectAll(event, this.sucmList, 'sucmName', 'selectedSucm', 'sucm');
  }

  async onChangeCommodity() {
    if (this.selectedCommodity.indexOf('Select All') === -1) {
      this.isAllCommoditiesSelected = false;
      this.commodityArr = this.selectedCommodity;
      if (this.commodityList.length === this.commodityArr.length) {
        this.isAllCommoditiesSelected = true;
      }
      window.localStorage.setItem('selectedCommodities', JSON.stringify(this.selectedCommodity));
      await this.fetchDataBasedOnSearch('commodity');
    }
  }

  async selectAllCommodities(event: any) {
    this.commodityArr = [];
    this.selectedCommodity = [];
    await this.handleSelectAll(event, this.commodityList, 'commodityName', 'selectedCommodities', 'commodity');
  }

  async fetchDataBasedOnSearch(val: any, isRedirectedFromAnotherTab?: any) {
    window.localStorage.setItem('type', 'login');
    const requestObj: any = {};
    requestObj.supplierName = '';
    requestObj.commodity = this.commodityArr;
    requestObj.sucm = this.sucmArr;

    this.loaderService.openLoader();
    await lastValueFrom(this.cepmService.fetchDataBasedOnSearch(requestObj))
      .then(async (respData: any) => {
        this.loaderService.closeLoader();
        if (val === 'sucm' || val === 'commodity') {
          if (this.commodityArr.length === 0 && this.sucmArr.length === 0) {
            this.supplierList = JSON.parse(window.localStorage.getItem('filterListResp')).supplier;
          }
          else {
            this.supplierList = respData.supplier;
          }
          if (val === 'commodity') {
            this.sucmList = respData.sucm;
            this.selectedCommodity = JSON.parse(window.localStorage.getItem('selectedCommodities'));
          }
        }
        else {
          this.commodityList = respData.commodity;
          this.sucmList = respData.sucm;
        }
        window.localStorage.setItem('commodityList', JSON.stringify(this.commodityList));
        window.localStorage.setItem('supplierList', JSON.stringify(this.supplierList));
        window.localStorage.setItem('sucmList', JSON.stringify(this.sucmList));

        const isFirstTimeSupplierSelected = JSON.parse(window.localStorage.getItem('isFirstTimeSupplierSelected'));

        if (!isRedirectedFromAnotherTab) {
          if (val === 'supplier' && !isFirstTimeSupplierSelected) {
            let redirectionFromTo: any = '';
            if (this.loggedInUser.role.value === 'supplier_commodity_manager_sucm') {
              redirectionFromTo = 'Sucm-Sucm Supplier';
            } 
            else if (this.loggedInUser.role.value === 'sourcing_commodity_manager_socm') {
              redirectionFromTo = 'Socm-Socm Supplier';
            } 
            else if (this.loggedInUser.role.value === 'commodity_directors') {
              redirectionFromTo = 'Director-Director Supplier';
            } 
            else if (this.loggedInUser.role.value === 'supply_chain_view_access') {
              redirectionFromTo = 'Sco-Sco Supplier';
            } 
            else if (this.loggedInUser.role.value === 'gsm_general_user_okta') {
              redirectionFromTo = 'General-General Supplier';
            } 
            else if (this.loggedInUser.role.value === 'scw_admin') {
              redirectionFromTo = 'AdminUser-AdminUser Supplier';
            } 
            else {
              redirectionFromTo = 'Admin-SCW Home';
            }
            window.localStorage.setItem('redirectedFrom-To', redirectionFromTo);
            window.localStorage.setItem('isFirstTimeSupplierSelected', 'true');
            this.sharedService.setRedirectionUrl('supplier-new-home');
          }
          else {
            if ((val === 'supplier' && this.mainTabs[Number(window.sessionStorage.getItem('selectedMainMenuIndex'))].mainTabName !== 'Admin')
              || (val === 'commodity' && (window.location.href.includes('/fulfillment')
                || window.location.href.includes('/sbr-score-card') || window.location.href.includes('/resiliency-score-card')
                || window.location.href.includes('/quality') || window.location.href.includes('/supplier-sustainability-score')))) {
              let currentUrl = this.router.url;
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([currentUrl]);
              });
            }
          }
        }
      })
      .catch((err: any) => {
        this.loaderService.closeLoader();
        this.openConfirmationPopup('Error', err.error.errorMsg, false);
      });
  }

  async getTools() {
    if (this.selectedSupplier !== 'ALL') {
      this.toolsList = [];
      if (!window.localStorage.getItem('toolsList')) {
        this.toolsList = [];
        const respData: any = await lastValueFrom(this.toolsService.getToolsDetails(this.selectedSupplier))
          .catch((err: any) => {
            this.openConfirmationPopup('Error', err.error.errorMsg, false);
            return null;
          });
        this.toolsList = respData || [];
        window.localStorage.setItem('toolsList', JSON.stringify(respData));
      }
      else {
        this.toolsList = JSON.parse(window.localStorage.getItem('toolsList'));
      }

      const defaultSubTab = {
        toolName: 'Tools : Detailed View',
        toolUrl: '/tools'
      };
      this.toolsList.unshift(defaultSubTab);

      const toolsTabIndex = this.mainTabs.findIndex(
        (mainTab) => mainTab.mainTabName === 'Tools' || mainTab.mainTabName === 'SC Apps'
      );
      if (toolsTabIndex === -1) return;

      // Helper to create a new tab group
      const createTabGroup = () => ({
        tabGroupName: '',
        tabGroupTooltip: '',
        tabGroupUrl: '',
        isTabGroupVisible: true,
        subTabs: []
      });

      // Reset tabGroups for this tab
      this.mainTabs[toolsTabIndex].tabGroups = [createTabGroup()];

      // Add tools to tabGroups, 5 per group
      this.toolsList.forEach((tool: any, index: number) => {
        const groupSize = 5;
        const groupIndex = Math.floor(index / groupSize);

        // Create new group if needed
        if (!this.mainTabs[toolsTabIndex].tabGroups[groupIndex]) {
          this.mainTabs[toolsTabIndex].tabGroups.push(createTabGroup());
        }

        this.mainTabs[toolsTabIndex].tabGroups[groupIndex].subTabs.push({
          subTabName: tool.toolName,
          subTabTooltip: tool.toolName,
          isSubTabVisible: true,
          subTabUrl: tool.toolUrl
        });
      });
    }
  }

  displaySelectedTabName() {
    if (this.mainTabs[Number(window.sessionStorage.getItem('selectedMainMenuIndex'))]) {
      if (this.mainTabs[Number(window.sessionStorage.getItem('selectedMainMenuIndex'))].tabGroups.length === 0) {
        return this.mainTabs[Number(window.sessionStorage.getItem('selectedMainMenuIndex'))].mainTabName;
      }
      else {
        return this.mainTabs[Number(window.sessionStorage.getItem('selectedMainMenuIndex'))].
          tabGroups[Number(window.sessionStorage.getItem('selectedTabMenuGrpIndex'))]
          .subTabs[Number(window.sessionStorage.getItem('selectedSubMenuIndex'))].subTabName;
      }
    }
  }

  displaySelectedSuplier() {
    if (this.mainTabs[Number(window.sessionStorage.getItem('selectedMainMenuIndex'))] &&
      this.mainTabs[Number(window.sessionStorage.getItem('selectedMainMenuIndex'))].mainTabName !== 'Admin') {
      return this.encDecSrvice.get(window.sessionStorage.getItem('selectedSupplier'));
    }
    else {
      return 'ALL';
    }
  }

  onClickReportIssues(val: any) {
    this.onClickFilterPanel('close');
    if (val === 'open') {
      this.reportIssuesInitialTab = 1;
    }
    this.openReportIssuesPopup = val === 'open' ? true : false;
  }

  onClickFeedbackLauncher() {
    this.onClickFilterPanel('close');
    const userType = this.routerConstants.getUserType();
    // Semantic initialTab: 0 = Feedback form, 2 = Feedback History (admin only).
    this.reportIssuesInitialTab = userType === 'scw_admin' ? 2 : 0;
    this.openReportIssuesPopup = true;
  }

  onClickQuickTour(val: any) {
    if (val === 'open') {
      this.isHelpPageOpened = true;
    }
    else if (val === 'sucm-quick-tour') {
      this.isHelpPageOpened = false;
      this.sharedService.setQuickTour(window.location.href.includes('watchlist') ? 'watchlist-quick-tour' : 'sucm-quick-tour');
    }
    else if (val === 'close') {
      this.isHelpPageOpened = false;
    }
  }

  onClickDataIntegrationIcon(val: any) {
    if (val === 'open') {
      this.dataRefreshGridConfig.rowData = [];
      this.isDataRefreshPopup = true;
      this.enableDataRefresh = true;
      this.enableEditInfo = false;
      this.infoEditorOpen = false;
      this.fadeOut = false; // Reset fade when opening
      this.loaderService.openLoader();
      this.loadSchedulerDetails();
    }
    else {
      this.isDataRefreshPopup = false;
      this.fadeOut = false; // Reset fade when opening
      this.stopDataRefreshPoll();
    }
  }

  openTimeOutPopup(msg: any) {
    this.timeoutModalRefBox = this.modalService.open(TimeoutComponent, {
      centered: true,
      windowClass: 'alertModalWindowClass',
      backdrop: 'static',
      keyboard: false,
    });
    this.timeoutModalRefBox.componentInstance.message = msg;
  }

  @HostListener('window:resize')
  onResize() {
    this.browserScreenHeight = window.innerHeight;
  }

  setHeightOfSupplierList() {
    let supplierListHeight = this.browserScreenHeight;
    const mainHeaderHeight: number = $('.app-header').innerHeight() ? $('.app-header').innerHeight() : 0;
    const footerHeight: number = $('.app-footer').innerHeight() ? $('.app-footer').innerHeight() : 0;
    supplierListHeight = Math.ceil(this.browserScreenHeight) - (45 + 45 + 65 + 65 + 65 + Math.ceil(mainHeaderHeight) + Math.ceil(footerHeight));
    // return supplierListHeight - 20;
    return supplierListHeight
  }

  setMainContainerHeight() {
    let mainContentHeight = this.browserScreenHeight;
    let mainHeaderHeight: number = $('.app-header').innerHeight() ? $('.app-header').innerHeight() : 0;
    let breadcrumHeight: number = $('#breadcrumb').innerHeight() ? $('#breadcrumb').innerHeight() : 0;

    const footerHeight: number = $('.app-footer').innerHeight() ? $('.app-footer').innerHeight() : 0;
    mainContentHeight = Math.ceil(this.browserScreenHeight) - (Math.ceil(mainHeaderHeight) + Math.ceil(footerHeight) + Math.ceil(breadcrumHeight));
    // mainContentHeight = mainContentHeight - 20;
    window.sessionStorage.setItem('mainContentHeight', mainContentHeight);
    return mainContentHeight;
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  openConfirmationPopup(title: any, msg: any, flag: any) {
     if (this.isDataRefreshPopup) {
    this.fadeOut = true;
  }
    this.modalRefBox = this.modalService.open(ConfirmationComponent, {
      centered: true,
      windowClass: 'alertModalWindowClass',
      backdrop: 'static',
      keyboard: false,
    });
    this.modalRefBox.componentInstance.title = title;
    this.modalRefBox.componentInstance.message = msg;
    this.modalRefBox.componentInstance.showCancelButton = flag;
    this.modalRefBox.result.then(
    (result) => {
      this.fadeOut = false;
    },
    (dismissed) => {
      this.fadeOut = false;
    }
    );  
  }

  setupActivityListener() {
    ['click', 'mousemove', 'keydown', 'scroll', 'touchstart'].forEach((event) => {
      document.body.addEventListener(event, () => {
        localStorage.setItem('lastActiveTime', new Date().toISOString());
        this.reset();
      });
    });
  }

  onMouseEnter(mainTab: MainMenuTab) {
    const mainMenuIndex = this.mainTabs.findIndex((mTab) => (mainTab.mainTabName === mTab.mainTabName) && (mainTab.labelName === mTab.labelName));
    this.selectedMainMenuIndex = mainMenuIndex;
    // if (mainTab.mainTabUrl) {
    //   window.localStorage.setItem('type', 'login');
    //   window.sessionStorage.setItem('selectedMainMenuIndex', this.selectedMainMenuIndex);
    //   this.selectedTabMenuGrpIndex = 0;
    //   window.sessionStorage.setItem('selectedTabMenuGrpIndex', this.selectedTabMenuGrpIndex);
    //   this.selectedSubMenuIndex = 0;
    //   window.sessionStorage.setItem('selectedSubMenuIndex', this.selectedSubMenuIndex);
    //   this.onClickMenuPanel('close');
    //   this.router.navigate([mainTab.mainTabUrl]);
    // }
    this.isHovering = true;
  }

  // Method to handle mouse leave event
  onMouseLeave() {
    this.selectedMainMenuIndex = Number(window.sessionStorage.getItem('selectedMainMenuIndex'));
    this.isHovering = false;
    this.isUserPersonaHovering = false;
  }

  generateBreadcrumbs(mainTabs: any[], data?: any) {
    let breadcrumbs = [];
    const selectedMainMenuIndex = Number(window.sessionStorage.getItem('selectedMainMenuIndex'));
    const selectedTabMenuGrpIndex = Number(window.sessionStorage.getItem('selectedTabMenuGrpIndex'));
    const selectedSubMenuIndex = Number(window.sessionStorage.getItem('selectedSubMenuIndex'));
    const selectedSupplier = this.encDecSrvice.get(window.sessionStorage.getItem('selectedSupplier'));
    if (selectedSupplier !== 'ALL' && this.loggedInUser?.role?.value !== 'scw_supplier_user') {
      breadcrumbs.push({ label: selectedSupplier, url: '/supplier-new-home' });
    }
    let mainTab: any = mainTabs.filter((m: any, i: any) => i === selectedMainMenuIndex);
    let hasSupplierSwitchedCompany = false;
    if (this.loggedInUser?.role?.value === 'scw_supplier_user') {
      hasSupplierSwitchedCompany = selectedSupplier !== this.loggedInUser.mcoCompany?.split('-RFQ')[0];
    }
    if (mainTab && mainTab.length > 0) {
      if (hasSupplierSwitchedCompany) {
        breadcrumbs.push(
          { label: this.loggedInUser.mcoCompany?.split('-RFQ')[0], url: '/supplier-new-home' },
          { label: 'Switch Company', url: '' },
          { label: selectedSupplier, url: '' }
        );
      }
      else {
        breadcrumbs.push({ label: mainTab[0].labelName, url: mainTab[0].mainTabUrl });
      }
      if (mainTab[0].tabGroups?.length > 0) {
        let tabGrp = mainTab[0].tabGroups.filter((t: any, i: any) => i === selectedTabMenuGrpIndex);
        if (tabGrp && tabGrp.length > 0) {
          if (tabGrp[0].tabGroupName) {
            breadcrumbs.push({ label: tabGrp[0].tabGroupName, url: tabGrp[0].tabGroupUrl });
          }
          let subTab = tabGrp[0].subTabs.filter((s: any, i: any) => i === selectedSubMenuIndex);
          if (subTab && subTab.length > 0) {
            breadcrumbs.push({ label: subTab[0].subTabName, url: subTab[0].subTabUrl });
          }
        }
      }
    }
    return breadcrumbs;
  }

  getTagLineLookupValues() {
    if (this.tagLineLookupRequested) {
      return;
    }
    this.tagLineLookupRequested = true;
    this.lookupService.getDropdownLookup('SCW_SUPP_TAG_LINE')
      .subscribe({
        next: (respData: any) => {
          this.SCWTagLine = respData.lookupArray[0].description;
        },
        error: (error: any) => {
          this.openConfirmationPopup('Error', error.error.errorMsg, false);
        }
      });
  }
  onMouseEnterPersona(flag: any) {
    this.isUserPersonaHovering = flag;
  }

  onClickMyCompanyFromPersona() {
    window.localStorage.setItem('redirectedFrom-To', 'SCW Home-Collaboration');
    window.localStorage.setItem('site-level-view', 'true');
    this.sharedService.setRedirectionUrl('contact-management');
  }

  addLink(obj: any): void {
    const existingIndex = this.visitedLinks.findIndex(link => link.linkUrl === obj.linkUrl);

    const visitedLinksString = sessionStorage.getItem('visitedLinks');
    if (visitedLinksString) {
      this.visitedLinks = JSON.parse(visitedLinksString);
    }
    if (existingIndex !== -1) {
      this.visitedLinks.splice(existingIndex, 1);
    }
    if (obj.linkUrl.startsWith('/') && obj.linkName !== 'My Company') {
      this.visitedLinks.unshift(obj);
      this.visitedLinks = this.visitedLinks.slice(0, this.maxLinks);
      window.sessionStorage.setItem('visitedLinks', JSON.stringify(this.visitedLinks));
    }
  }

  onClickRecentVisits(obj: any) {
    this.isUserPersonaHovering = false;
    window.localStorage.setItem('redirectedFrom-To', 'Home-' + obj.mainTabName);
    this.sharedService.setRedirectionUrl(obj.linkUrl.replace(/\//, ''));
  }

  onRemoveSupplierRecentVisit() {
    if (this.loggedInUser.role.value !== 'scw_supplier_user') {
      const visitedLinksString = sessionStorage.getItem('visitedLinks');
      if (visitedLinksString) {
        this.visitedLinks = JSON.parse(visitedLinksString);
        let filteredVisitedLinks = this.visitedLinks.filter(item => item.supplier === 'ALL');
        this.visitedLinks = filteredVisitedLinks.slice(0, this.maxLinks);
        window.sessionStorage.setItem('visitedLinks', JSON.stringify(this.visitedLinks));
      }
    }
  }

  scrollMessage() {
    setTimeout(() => {
      this.dataService.currentData.subscribe((data) => {
        this.scrollMsg = data;
      });
    }, 500);
  }

  toggleFavorite(breadcrumb: any) {
    const index = this.favorites.findIndex(fav => fav.URL === breadcrumb.url);
    if (index === -1) {
      this.favorites.push({ LABEL: breadcrumb.label, URL: breadcrumb.url });
      this.showToast("Added to favorites");
    }
    else {
      this.favorites.splice(index, 1);
      this.showToast("Removed from favorites");
    }

    localStorage.setItem('favorites', JSON.stringify(this.favorites));
    this.navigationService.updateFavorites(this.favorites)
      .subscribe({
        next: (respData: any) => {
          this.loadFavorites();
        },
        error: (err: any) => {
          this.loaderService.closeLoader();
          this.openConfirmationPopup('Error', err.error.errorMsg, false);
        }
      });
  }

  isFavorite(breadcrumb: any): boolean {
    return this.favorites.some(fav => fav.URL === breadcrumb.url);
  }

  loadFavorites() {
    if (this.loggedInUser.role.value !== 'scw_supplier_user' && !this.favoritesLoadInProgress) {
      this.favoritesLoadInProgress = true;
      this.favorites = [];
      this.navigationService.geFavorites()
        .subscribe({
          next: (respData: any) => {
            this.favoritesLoadInProgress = false;
            if (respData && respData.length > 0) {
              this.favorites = respData;
              this.getFavorites();
            }
          },
          error: (err: any) => {
            this.favoritesLoadInProgress = false;
            this.loaderService.closeLoader();
            this.openConfirmationPopup('Error', err.error.errorMsg, false);
          }
        });
    }
  }

  getFavorites() {
    let toolsLength = 5;
    const toolsTabIndex = this.mainTabs.findIndex((mainTab) => (mainTab.mainTabName === 'Favorites'));
    if (this.mainTabs[toolsTabIndex] && this.mainTabs[toolsTabIndex].tabGroups) {
      this.mainTabs[toolsTabIndex].tabGroups[this.mainTabs[toolsTabIndex].tabGroups.length - 1].subTabs = [];
    }
    if (toolsTabIndex === -1) {
      return;
    }
    //  this.mainTabs[toolsTabIndex].tabGroups.push({
    //   tabGroupName: '',
    //   tabGroupTooltip: '',
    //   tabGroupUrl: '',
    //   isTabGroupVisible: true,
    //   subTabs: []
    // });

    this.mainTabs[toolsTabIndex].tabGroups = [{
      tabGroupName: '',
      tabGroupTooltip: '',
      tabGroupUrl: '',
      isTabGroupVisible: true,
      subTabs: []
    }];
    this.favorites.forEach((tool: any, index: any) => {
      if ((index === toolsLength)) {
        this.mainTabs[toolsTabIndex].tabGroups.push({
          tabGroupName: '',
          tabGroupTooltip: '',
          tabGroupUrl: '',
          isTabGroupVisible: true,
          subTabs: []
        });
        toolsLength += 5;
      }


      //toolsLength = 5 * this.mainTabs[toolsTabIndex].tabGroups.length;

      if (index < toolsLength) {
        this.mainTabs[toolsTabIndex].tabGroups[this.mainTabs[toolsTabIndex].tabGroups.length - 1].subTabs.push({
          subTabName: tool.LABEL,
          subTabTooltip: tool.LABEL,
          isSubTabVisible: true,
          subTabUrl: tool.URL
        });
      }
    });

  }

  private normalizeRouteUrl(url: string): string {
    const path = (url || '').split('?')[0].split('#')[0];
    if (!path || path === '/') {
      return path;
    }
    return path.endsWith('/') ? path.slice(0, -1) : path;
  }

 findMatchingTabByUrl(url: string) {
    const normalizedUrl = this.normalizeRouteUrl(url);
    let mainTabs = this.mainTabs.filter((mTab: any) => mTab.isMainTabVisible);
    let matches: any[] = [];
    
    // Find all matching tabs
    for (let mainTab of mainTabs) {
      for (let tabGroup of mainTab.tabGroups) {
        for (let subTab of tabGroup.subTabs) {
          if (subTab.subTabUrl === normalizedUrl && subTab.isSubTabVisible) {
            matches.push({ mainTab, tabGroup, subTab });
          }
        }
      }
    }
    
    // If multiple matches found, always prioritize Admin menu
    if (matches.length > 1) {
      const adminMatch = matches.find(match => match.mainTab.labelName === 'Admin');
      if (adminMatch) {
        return adminMatch;
      }
    }
    
    // Return first match if only one or no prioritization applied
    return matches.length > 0 ? matches[0] : null;
  }

  /** Restore menu highlight + breadcrumbs after F5 on a deep-linked lazy route (e.g. /data-refresh). */
  private syncMenuSelectionFromCurrentUrl(): void {
    const url = this.normalizeRouteUrl(this.router.url);
    const match = this.findMatchingTabByUrl(url);
    if (!match || !this.mainTabs?.length) {
      this.breadcrumbs = this.generateBreadcrumbs(this.mainTabs);
      return;
    }

    this.selectedMainMenuIndex = this.mainTabs.findIndex(
      (mTab) => match.mainTab.mainTabName === mTab.mainTabName && match.mainTab.labelName === mTab.labelName,
    );
    if (this.selectedMainMenuIndex < 0) {
      this.breadcrumbs = this.generateBreadcrumbs(this.mainTabs);
      return;
    }

    const mainTab = this.mainTabs[this.selectedMainMenuIndex];
    this.selectedTabMenuGrpIndex = 0;
    this.selectedSubMenuIndex = 0;
    for (let tbGrpIndex = 0; tbGrpIndex < mainTab.tabGroups.length; tbGrpIndex++) {
      const tabGrp = mainTab.tabGroups[tbGrpIndex];
      for (let sTabIndex = 0; sTabIndex < tabGrp.subTabs.length; sTabIndex++) {
        const subTab = tabGrp.subTabs[sTabIndex];
        if (subTab.subTabUrl === match.subTab.subTabUrl && subTab.subTabName === match.subTab.subTabName) {
          this.selectedTabMenuGrpIndex = tbGrpIndex;
          this.selectedSubMenuIndex = sTabIndex;
          break;
        }
      }
    }

    window.sessionStorage.setItem('selectedMainMenuIndex', String(this.selectedMainMenuIndex));
    window.sessionStorage.setItem('selectedTabMenuGrpIndex', String(this.selectedTabMenuGrpIndex));
    window.sessionStorage.setItem('selectedSubMenuIndex', String(this.selectedSubMenuIndex));
    this.breadcrumbs = this.generateBreadcrumbs(this.mainTabs);
    this.cdRef.detectChanges();
  }

  navigateToTab(mainTab: MainMenuTab, tabGroup: TabMenuGroup, subTab: SubMenuTabs) {
    const mainMenuIndex = this.mainTabs.findIndex((mTab) => (mainTab.mainTabName === mTab.mainTabName) && (mainTab.labelName === mTab.labelName));
    this.selectedMainMenuIndex = mainMenuIndex;
    window.sessionStorage.setItem('selectedMainMenuIndex', this.selectedMainMenuIndex);

    let mTab = this.mainTabs[this.selectedMainMenuIndex];
    for (let tbGrpIndex = 0; tbGrpIndex < mTab.tabGroups.length; tbGrpIndex++) {
      let tbGrp = mTab.tabGroups[tbGrpIndex];
      for (let sTabIndex = 0; sTabIndex < tbGrp.subTabs.length; sTabIndex++) {
        let sTab = tbGrp.subTabs[sTabIndex];
        if (sTab.subTabUrl === subTab.subTabUrl && sTab.subTabName === subTab.subTabName) {
          this.selectedTabMenuGrpIndex = tbGrpIndex;
          this.selectedSubMenuIndex = sTabIndex;
          break;
        }
      }
    }

    window.sessionStorage.setItem('selectedTabMenuGrpIndex', this.selectedTabMenuGrpIndex);
    window.sessionStorage.setItem('selectedSubMenuIndex', this.selectedSubMenuIndex);

    const selectedSupplier = this.mainTabs[this.selectedMainMenuIndex].labelName === 'Admin' ? 'ALL' : this.selectedSupplier;
    window.localStorage.setItem('selectedSupplier', this.encDecSrvice.set(selectedSupplier));
    window.sessionStorage.setItem('selectedSupplier', this.encDecSrvice.set(selectedSupplier));

    let currentUrl = this.router.url;
    if (currentUrl === subTab.subTabUrl) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([currentUrl]);
      });
    } else {
      this.router.navigateByUrl('/').then(() => {
        this.router.navigate([subTab.subTabUrl]);
      });
    }
  }

  showToast(message: string) {
    this.snackBar.open(message, '', {
      duration: 2000,
      horizontalPosition: 'left',
      verticalPosition: 'top',
      panelClass: ['custom-snackbar']
    });
  }

  onClickLastBreadCrum(url) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([url]);
    });
  }

  isCiscoDomainUser(): boolean {
    return this.loggedInUser?.email?.endsWith('@cisco.com') || false;
  }

  @HostListener('document:visibilitychange')
  onVisibilityChange() {

    const now = Date.now();
    if (now - this.lastVisibilityCheck < 1000) {
      return;
    }
    this.lastVisibilityCheck = now;

    // Don't redirect if already in process of redirecting
    if (this.isRedirecting) {
      return;
    }

    if (document.visibilityState !== 'visible') {
     return;
    }
    // Add more specific checks to prevent false redirects
  const hasAuthData = window.localStorage.getItem('adata') !== null;
  const hasRefreshToken = window.localStorage.getItem('rtoken') !== null;
  const isOnAuthPages = ['/logout', '/', '/callback', '/no-cepm-role'].includes(this.router.url);
  
  // Only redirect if we're truly unauthenticated and not already on auth pages
  if (!hasAuthData && !hasRefreshToken && !this.isLoggedIn && !isOnAuthPages) {
    // Add a small delay to ensure other processes complete
    setTimeout(() => {
      if (!this.isRedirecting) {
        this.isRedirecting = true;
        this.logout();
      }
    }, 100);
  }
  }

  ngOnDestroy(): void {
    this.newsInfoSub?.unsubscribe();
    this.visibilitySuppliersSub?.unsubscribe();
    this.stopDataRefreshPoll();
  }

  private mapSchedulerDetailRow(item: any): any {
    const running = ['RUNNING', 'IN_PROGRESS', 'In Progress'].includes(item.jobStatus);
    const jobStatus = running ? 'In Progress' : item.jobStatus;
    return {
      ...item,
      isRefreshing: jobStatus === 'In Progress',
      jobStatus,
    };
  }

  private hasInProgressRows(): boolean {
    return (this.dataRefreshGridConfig.rowData || []).some(
      (row: any) => row.jobStatus === 'In Progress' || row.jobStatus === 'RUNNING'
    );
  }

  private stopDataRefreshPoll(): void {
    this.pollStop$.next();
    this.pollStop$.complete();
    this.pollStop$ = new Subject<void>();
    if (this.dataRefreshPollSub) {
      this.dataRefreshPollSub.unsubscribe();
      this.dataRefreshPollSub = undefined;
    }
  }

  private startDataRefreshPollIfNeeded(): void {
    if (this.dataRefreshPollSub || !this.hasInProgressRows()) {
      return;
    }

    const pollDeadline$ = timer(5 * 60 * 1000);

    this.dataRefreshPollSub = interval(3000)
      .pipe(
        takeUntil(pollDeadline$),
        takeUntil(this.pollStop$),
        switchMap(() => this.cepmService.getSchedularDetails())
      )
      .subscribe({
        next: (respData: any) => {
          if (!respData || respData.length === 0) {
            return;
          }

          const previousByMetric = new Map<string, string>(
            (this.dataRefreshGridConfig.rowData || []).map((row: any) => [row.metric, row.jobStatus])
          );

          this.dataRefreshGridConfig.rowData = respData.map((item: any) => this.mapSchedulerDetailRow(item));

          this.dataRefreshGridConfig.rowData.forEach((row: any) => {
            const previousStatus = previousByMetric.get(row.metric);
            if (
              previousStatus === 'In Progress' &&
              (row.jobStatus === 'Completed' || row.jobStatus === 'Failed')
            ) {
              this.showToast(`Manual refresh ${row.jobStatus} for ${row.metric}`);
            }
          });

          if (this.dataRefreshGrid?.api) {
            this.dataRefreshGrid.api.setGridOption('rowData', this.dataRefreshGridConfig.rowData);
            this.dataRefreshGrid.api.refreshCells({ columns: ['refreshAction', 'jobStatus'], force: true });
            this.dataRefreshGrid.api.sizeColumnsToFit();
          }

          if (!this.hasInProgressRows()) {
            this.stopDataRefreshPoll();
          }
        },
        complete: () => {
          if (this.hasInProgressRows()) {
            this.showToast('Manual refresh polling timed out after 5 minutes');
          }
          this.dataRefreshPollSub = undefined;
        },
      });
  }

  onRefresh(data: any) {
    if (data.isRefreshing || data.jobStatus === 'In Progress') {
      return;
    }

    data.isRefreshing = true;
    data.jobStatus = 'In Progress';
    data.errorMessage = '';
    if (this.dataRefreshGrid?.api) {
      this.dataRefreshGrid.api.redrawRows();
    }
    this.showToast(`Manual refresh started for ${data.metric}`);

    this.cepmService.refreshStatus(data.metric).subscribe({
      next: () => this.startDataRefreshPollIfNeeded(),
      error: (err: HttpErrorResponse) => {
        if (err.status === 409) {
          data.isRefreshing = true;
          data.jobStatus = 'In Progress';
          if (this.dataRefreshGrid?.api) {
            this.dataRefreshGrid.api.redrawRows();
          }
          this.showToast(`Refresh already in progress for ${data.metric}`);
          this.startDataRefreshPollIfNeeded();
          return;
        }

        data.isRefreshing = false;
        if (this.dataRefreshGrid?.api) {
          this.dataRefreshGrid.api.redrawRows();
        }
        this.loadSchedulerDetails();
        if (err.status === 400) {
          this.showToast(`Invalid job: ${data.metric}`);
        } else {
          this.showToast(`Failed to trigger refresh for ${data.metric}`);
        }
      },
    });
  }

  loadSchedulerDetails() {
    this.cepmService.getSchedularDetails().subscribe({
      next: (respData: any) => {
        this.loaderService.closeLoader();
        if (respData && respData.length > 0) {
          // TODO: ESG metrics temporarily hidden while ESG features are disabled
          const hiddenEsgMetrics = [
            'ESG Score(Supplier Soft Risk Smelters)',
            'ESG Score(SUPPLIER COMPLIANT STATUS)',
            'ESG Score(Supplier Redline Case Tracker Manual Upload)',
            'ESG Score(COC RBA RECOG)'
          ];
          this.dataRefreshGridConfig.rowData = respData
            .filter((item: any) => !hiddenEsgMetrics.includes(item.metric))
            .map((item: any) => this.mapSchedulerDetailRow(item));
          if (this.loggedInUser.role.value !== "scw_admin") {
            this.dataRefreshGrid.api.setColumnsVisible(["action"], false);
          }
          this.dataRefreshGrid.api.sizeColumnsToFit();
          this.startDataRefreshPollIfNeeded();
        }
      },
      error: (err: any) => {
        this.loaderService.closeLoader();
        this.openConfirmationPopup("Error", err.error.errorMsg, false);
      },
    });
  }

  getNewsInfo(forceRefresh = false) {
    this.scrollMsg = '';
    const emailId = this.routerConstants.getLoggedInUser()?.email;
    const supplierName = this.encDecSrvice.get(window.localStorage.getItem('selectedSupplier'));

    if (!emailId || supplierName === 'ALL') {
      return;
    }

    const requestKey = `${supplierName}|${emailId}`;
    if (!forceRefresh && requestKey === this.lastNewsInfoRequestKey) {
      return;
    }
    this.lastNewsInfoRequestKey = requestKey;
    this.newsInfoSub?.unsubscribe();

    this.newsInfoSub = this.supplierService.getNewsInfo(supplierName, emailId).subscribe({
      next: (respData: any) => {
        if (respData && Object.keys(respData).length > 0) {

          if (respData.scrollMsgList.length > 0) {
            this.scrollMsg = this.htmlToPlaintext(respData.scrollMsgList[0].messageBody);
          }
        }
      },
      error: (err: any) => {
        this.lastNewsInfoRequestKey = '';
        this.loaderService.closeLoader();
        this.openConfirmationPopup("Error", err.error.errorMsg, false);
      },
    });
  }
  htmlToPlaintext(text: any) {
    if (!text) return '';
    return new DOMParser().parseFromString(text, 'text/html').body.textContent;
  }

  onClickInfo(action: string) {
    if (action === 'open') {
      this.enableDataRefresh = false;
      this.enableEditInfo = true;
      this.getInfoData();
    }
  }

  openDataRefreshInfoPopup(): void {
    this.isDataRefreshPopup = true;
    this.enableDataRefresh = false;
    this.enableEditInfo = true;
    this.infoEditorOpen = false;
    this.fadeOut = false;
    this.getInfoData();
    this.cdRef.detectChanges();
  }

  onClickInfoEdit(action: string) {
    this.infoEditorOpen = action === 'open';
    this.dataRefreshInfoBody = this.dataRefreshInfoRes;
    this.cdRef.detectChanges();
    this.scheduleEditorEditMode();
  }

  private getFroalaEditor(): any {
    return this.editorInstance?._editor ?? this.editorInstance;
  }

  private scheduleEditorEditMode(attempt = 0): void {
    setTimeout(() => {
      this.setEditorMaxHeight();
      const editor = this.getFroalaEditor();
      if (editor?.edit) {
        if (this.infoEditorOpen) {
          editor.edit.on();
        } else {
          editor.edit.off();
        }
        return;
      }
      if (attempt < 10) {
        this.scheduleEditorEditMode(attempt + 1);
      }
    }, attempt === 0 ? 100 : 200);
  }

  getMasterAndChildLookupIds() {
    this.loaderService.openLoader();
    this.lookupService.viewMasterLookup('COMMON')
      .subscribe({
        next: (resp: any) => {
          this.loaderService.closeLoader();
          if (resp?.masterLookUp?.length > 0) {
            const masterLookup = resp.masterLookUp.filter((elem: any) => elem.lookupType === 'SCW_DATA_REFRESH_INFO');
            this.loaderService.openLoader();
            this.lookupService.viewChildLookup(masterLookup[0])
              .subscribe({
                next: (respData: any) => {
                  this.loaderService.closeLoader();
                  this.onSaveOrUpdateDataRefreshInfo(masterLookup[0].masterLookupId, respData.childLookUp[0].childLookupId);
                },
                error: (err: any) => {
                  this.loaderService.closeLoader();
                  this.openConfirmationPopup('Error', err.error.errorMsg, false);
                }
              });
          }
        },
        error: (err: any) => {
          this.loaderService.closeLoader();
          this.openConfirmationPopup('Error', err.error.errorMsg, false);
        }
      });
  }

  onSaveOrUpdateDataRefreshInfo(masterlookupId: any, childLookupId: any) {
    const requestObj: any = {};
    requestObj.masterLookupId = Number(masterlookupId);
    requestObj.childLookupId = Number(childLookupId);
    requestObj.lookupCode = 'SCW_DATA_REFRESH_INFO';
    requestObj.updateEnable = 'Y';
    requestObj.lookupDesc = this.dataRefreshInfoBody ? this.dataRefreshInfoBody.replace(/’/g, `'`) : this.dataRefreshInfoBody;
    requestObj.lookupType = 'SCW_DATA_REFRESH_INFO';
    requestObj.lookupValue = 'SCW_DATA_REFRESH_INFO';

    this.loaderService.openLoader();
    this.lookupService.saveOrUpdateLookupValue(requestObj).subscribe({
      next: (respData: any) => {
        this.loaderService.closeLoader();
        if (Object.keys(respData).length !== 0 && respData.status === 'S') {
          this.openConfirmationPopup('Confirmation', `Data Refresh Information updated Sucessfully.`, false);
          this.fadeOut  = true;
          this.getInfoData();
          this.onClickInfoEdit('close');
        }
        else if (Object.keys(respData).length !== 0 && respData.status === 'E' && respData.errorMsg) {
          this.openConfirmationPopup('Error', respData.errorMsg, false);
        }
        else {
          this.openConfirmationPopup('Error', `Data Refresh Information Not updated. Try Again Later.`, false);
        }
      },
      error: (err: any) => {
        this.loaderService.closeLoader();
        this.openConfirmationPopup('Error', err.error.errorMsg, false);
      }
    });
  } 

  getInfoData() {
    this.dataRefreshInfoRes = '';
    let lookupType = 'SCW_DATA_REFRESH_INFO';    
    this.loaderService.openLoader();
    this.lookupService.getDropdownLookup(lookupType)
      .subscribe({
        next: (respData: any) => {
          this.loaderService.closeLoader();
          if (respData && respData.lookupArray && respData.lookupArray.length > 0) {
            this.dataRefreshInfoRes = respData.lookupArray[0].description;
            this.dataRefreshInfoBody = this.dataRefreshInfoRes;
            this.cdRef.detectChanges();
            setTimeout(() => {
              this.setEditorMaxHeight();
              this.getFroalaEditor()?.edit?.off();
            }, 500);

          }
        },
        error: (err: any) => {
          this.loaderService.closeLoader();
          this.openConfirmationPopup('Error', err.error.errorMsg, false);
        }
      });
  }

  setFroalaHeight() {
    const mainContentHeight = Number(window.sessionStorage.getItem('mainContentHeight')) - Number($('#data-refresh-modal-header').innerHeight() );
    return mainContentHeight - 10;
  }

  isInvalidFileSize(file: any) {
    if (Math.round(file.size / 1024) > 512) {
      alert('The uploaded image size exceeds the 512 KB limit.');
      return true;
    }
    else {
      return false;
    }
  }
  isInvalidFileExtension(file: any): any {
    const supportedFileTypes = ['PNG', 'JPEG', 'JPG', 'BMP'];
    const fileNameParts = file.name.split('.');
    const fileExt = fileNameParts.length > 1 ? fileNameParts[fileNameParts.length - 1].toUpperCase() : '';
    if (!supportedFileTypes.includes(fileExt)) {
      alert(`Only the following file types are supported: ${supportedFileTypes.join(', ')}`);
      return true;
    } else {
      return false;
    }
  }

setEditorMaxHeight() {
  const froalaEditor = this.getFroalaEditor();
  if (!froalaEditor?.$el?.[0]) {
    return;
  }
  const editorElement = document.getElementById('original-froala-editor-refresh-data-info');
  let toolbarHeight = 0;
  const toolbar = editorElement?.querySelector('.fr-toolbar');
  if (toolbar) {
    toolbarHeight = Number(window.getComputedStyle(toolbar).height.split('px')[0]);
  }
  const editorElem = $(froalaEditor.$el[0]);
  if (editorElem.length) {
    const editorHeight = `${this.setFroalaHeight() - toolbarHeight}px`;
    editorElem.css({ 'max-height': editorHeight, 'min-height': editorHeight });
  }
}

  async checkForApplicationUpdates() {
    if (this.swUpdate.isEnabled) {
      // Periodically check for a new version (e.g., every 60 seconds)
      setInterval(async () => {
        try {
          await this.swUpdate.checkForUpdate();
        } catch (err) {
          console.error('Failed to check for updates:', err);
        }
      }, 60000);

      // When a new version is ready, activate it and reload
      this.swUpdate.versionUpdates
        .pipe(
          filter((evt: any) => evt.type === 'VERSION_READY')
        )
        .subscribe(() => { (async () => {
          // console.log('New version detected. Activating update...');
          await this.swUpdate.activateUpdate();
          // window.location.reload();
        })(); });
    }
  }
  getCrossChildVisibitySuppliers(forceRefresh = false) {
    const supplierName = this.loggedInUser?.mcoCompany?.split('-RFQ')[0];
    if (!supplierName) {
      return;
    }

    const requestKey = supplierName;
    if (!forceRefresh && requestKey === this.lastVisibilitySuppliersRequestKey) {
      return;
    }
    this.lastVisibilitySuppliersRequestKey = requestKey;
    this.visibilitySuppliersSub?.unsubscribe();

    this.visibilitySuppliersSub = this.supplierService.getVisibilitySuppliersList(supplierName)
      .subscribe({
        next: (respData: any) => {
          if (respData?.status?.toUpperCase() === 'SUCCESS') {
            this.visibilitySupplierList = respData.suppliers.filter((s: any) => s !== supplierName);
          } else {
            this.visibilitySupplierList = [];
          }

          if (this.visibilitySupplierList.length > 0) {
            const hasSwitchCompanyTab = this.mainTabs.some(
              (tab) => tab.mainTabName === 'Switch Company'
            );
            if (!hasSwitchCompanyTab) {
              this.mainTabs.push(this.generateTabForSwitchCompany());
              this.cdRef.detectChanges();
            }
          }
        },
        error: () => {
          this.lastVisibilitySuppliersRequestKey = '';
        }
      });
  }
}